import React, { useState, useEffect, useRef } from 'react';
import { supabase } from '../supabase';
import { softDelete, softDeleteHijos } from '../utils/softDelete';
import { emitTareaChanged, onTareaChanged } from '../utils/tareasBus';
import { emitEntidadChanged } from '../utils/entidadBus';
import ClienteDetalle from './ClienteDetalle';
import ClienteModal from '../components/ClienteModal';
import TareaDetalle from '../components/TareaDetalle';
import ConfirmModal from '../components/ConfirmModal';
import { useEsAdmin } from '../UserContext';
import {
  DndContext, DragOverlay, PointerSensor, useSensor, useSensors,
  pointerWithin, rectIntersection,
} from '@dnd-kit/core';
import {
  SortableContext, useSortable, arrayMove, verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const TIPO_PRUEBA = {
  testimonial:    { label: 'Testimonial',    color: '#3b82f6', campo_nombre: 'Nombre del testigo' },
  confesional:    { label: 'Confesional',    color: '#8b5cf6', campo_nombre: 'Nombre de la parte' },
  pericia:        { label: 'Pericia',        color: '#f59e0b', campo_nombre: null },
  informativa:    { label: 'Informativa',    color: '#10b981', campo_nombre: 'Destinatario' },
  reconocimiento: { label: 'Reconocimiento', color: '#ef4444', campo_nombre: 'Objeto/Parte' },
  constatacion:   { label: 'Constatación',   color: '#f97316', campo_nombre: 'Objeto' },
  otro:           { label: 'Otro',           color: '#9ca3af', campo_nombre: null },
};
const ESTADO_PRUEBA = {
  no_instada:    { bg: 'var(--surface2)', color: '#64748b', border: 'var(--border)',  label: 'No instada'    },
  en_produccion: { bg: '#dbeafe',         color: '#1d4ed8', border: '#bfdbfe',        label: 'En producción' },
  completada:    { bg: '#dcfce7',         color: '#15803d', border: '#bbf7d0',        label: 'Completada'    },
  desistida:     { bg: '#fefce8',         color: '#a16207', border: '#fde68a',        label: 'Desistida'     },
};

export default function ExpedienteDetalle({ expedienteId, onClose, onUpdate, onNavigateExpediente, backLabel }) {
  const esAdmin = useEsAdmin();
  const [expediente, setExpediente] = useState(null);
  const [tareas, setTareas] = useState([]);
  const [movimientos, setMovimientos] = useState([]);
  const [audiencias, setAudiencias] = useState([]);
  const [notas, setNotas] = useState([]);
  const [nuevaNota, setNuevaNota] = useState('');
  const [loading, setLoading] = useState(true);
  const [tabActiva, setTabActiva] = useState('tareas');
  const [toast, setToast] = useState(null);
  const [verCliente, setVerCliente] = useState(null);
  const [clienteEdit, setClienteEdit] = useState(null);
  const [modalTareaOpen, setModalTareaOpen] = useState(false);
  const [guardandoTarea, setGuardandoTarea] = useState(false);
  const [modalMovOpen, setModalMovOpen] = useState(false);
  const [modalAudienciaOpen, setModalAudienciaOpen] = useState(false);
  const [editingAudienciaId, setEditingAudienciaId] = useState(null);
  const [audienciaError, setAudienciaError] = useState('');
  const [audienciaDetalleId, setAudienciaDetalleId] = useState(null);
  const [formAudiencia, setFormAudiencia] = useState({
    titulo: '', tipo: 'Audiencia', fecha: '', hora: '00:00', notas: '', estado: 'pendiente', grupo: ''
  });
  const [editingTareaId, setEditingTareaId] = useState(null);
  const [mostrarCompletadas, setMostrarCompletadas] = useState(false);
  const [mostrarDescartadas, setMostrarDescartadas] = useState(false);
  const [mostrarRealizadas, setMostrarRealizadas] = useState(false);
  const [mostrarCanceladas, setMostrarCanceladas] = useState(false);
  const [confirm, setConfirm] = useState(null); // { titulo, mensaje, onConfirmar }

  // Estado procesal
  const [etapaActual, setEtapaActual] = useState(null);
  const [historialEtapas, setHistorialEtapas] = useState([]);
  const [requisitosEtapa, setRequisitosEtapa] = useState([]);
  const [etapasPlantilla, setEtapasPlantilla] = useState([]);
  const [modalCambiarEtapa, setModalCambiarEtapa] = useState(false);
  const [modalEditarEtapa, setModalEditarEtapa] = useState(false);
  const [nombreEtapaEdit, setNombreEtapaEdit] = useState('');
  const [etapaHistorialDetalle, setEtapaHistorialDetalle] = useState(null);
  const [nuevaEtapaNombre, setNuevaEtapaNombre] = useState('');
  const [etapaPersonalizada, setEtapaPersonalizada] = useState(false);
  const [editReqId, setEditReqId] = useState(null);
  const [editReqData, setEditReqData] = useState({});
  const [modalNuevoReq, setModalNuevoReq] = useState(false);
  const [nuevoReqTexto, setNuevoReqTexto] = useState('');
  const [togglingReq, setTogglingReq] = useState(new Set());
  const [requisitoDetalleId, setRequisitoDetalleId] = useState(null);
  const [formReqDetalle, setFormReqDetalle] = useState({});
  const [guardandoReq, setGuardandoReq] = useState(false);

  const [formTarea, setFormTarea] = useState({
    titulo: '', descripcion: '', fecha: '', fecha_vencimiento: '', prioridad: 'normal', fijada: false, grupo: ''
  });
  const [notasTarea, setNotasTarea] = useState([]);
  const [nuevaNotaTarea, setNuevaNotaTarea] = useState('');
  const [formMov, setFormMov] = useState({ descripcion: '', fecha: '' });

  // Expedientes vinculados
  const [expedientePrincipal, setExpedientePrincipal] = useState(null);
  const [incidentes, setIncidentes] = useState([]);
  const [modalNuevoIncidente, setModalNuevoIncidente] = useState(false);
  const [guardandoIncidente, setGuardandoIncidente] = useState(false);
  const [formIncidente, setFormIncidente] = useState({ caratula: '', numero: '' });

  const [tiposJuicio, setTiposJuicio] = useState([]);

  const [tareaDetalleId, setTareaDetalleId] = useState(null);
  const [toggling, setToggling] = useState(new Set());

  // Prueba
  const [pruebas, setPruebas] = useState([]);
  const [modalPruebaOpen, setModalPruebaOpen] = useState(false);
  const [editingPruebaId, setEditingPruebaId] = useState(null);
  const [pruebaDetalleId, setPruebaDetalleId] = useState(null);
  const [guardandoPrueba, setGuardandoPrueba] = useState(false);
  const [formPrueba, setFormPrueba] = useState({ tipo: 'testimonial', estado: 'no_instada', descripcion: '', nombre: '', parte: 'nuestra' });
  const [pruebaEventos, setPruebaEventos] = useState([]);
  const [modalEventoOpen, setModalEventoOpen] = useState(false);
  const [formEvento, setFormEvento] = useState({ tipo: 'nota', descripcion: '', fecha: '', hora: '00:00' });
  const [guardandoEvento, setGuardandoEvento] = useState(false);
  const [tareasPruebaRef, setTareasPruebaRef] = useState({});
  const [audienciasPruebaRef, setAudienciasPruebaRef] = useState({});
  const [modalEditarExp, setModalEditarExp] = useState(false);
  const [formEditExp, setFormEditExp] = useState({});
  const [guardandoExp, setGuardandoExp] = useState(false);
  const [busquedaConvertir, setBusquedaConvertir] = useState('');
  const [resultadosConvertir, setResultadosConvertir] = useState([]);
  const [dropdownConvertirOpen, setDropdownConvertirOpen] = useState(false);
  const [principalConvertir, setPrincipalConvertir] = useState(null);

  // Clientes en el modal de edición
  const [todosClientes, setTodosClientes] = useState([]);
  const [busquedaClienteEdit, setBusquedaClienteEdit] = useState('');
  const [dropdownClienteEditOpen, setDropdownClienteEditOpen] = useState(false);

  // Grupos
  const [gruposColapsados, setGruposColapsados] = useState({});
  const [nuevoGrupoInlineOpen, setNuevoGrupoInlineOpen] = useState(false);
  const [nuevoGrupoNombre, setNuevoGrupoNombre] = useState('');
  const [renombrandoGrupo, setRenombrandoGrupo] = useState(null);
  const [renombreValor, setRenombreValor] = useState('');
  const [formTareaGrupoNuevo, setFormTareaGrupoNuevo] = useState(false);
  const [formTareaGrupoNuevoValor, setFormTareaGrupoNuevoValor] = useState('');
  const [gruposOrden, setGruposOrden] = useState([]); // array ordenado de nombres de grupos (tareas)
  const [gruposAudienciasOrden, setGruposAudienciasOrden] = useState([]); // idem audiencias
  const [modalGrupoAudOpen, setModalGrupoAudOpen] = useState(false);
  const [nuevoGrupoAudInput, setNuevoGrupoAudInput] = useState('');
  // @dnd-kit (tareas)
  const [activeDragId, setActiveDragId] = useState(null);
  const [contenedoresDrag, setContenedoresDrag] = useState(null);
  const contenedoresRef = useRef(null);
  // @dnd-kit (audiencias)
  const [activeDragAudId, setActiveDragAudId] = useState(null);
  const [contenedoresAudDrag, setContenedoresAudDrag] = useState(null);
  const contenedoresAudRef = useRef(null);

  // Modal asignar tarea / grupo / audiencia
  const [modalAsignarOpen, setModalAsignarOpen] = useState(false);
  const [asignarItems, setAsignarItems] = useState([]);
  const [asignarTitulo, setAsignarTitulo] = useState('');
  const [asignarTipo, setAsignarTipo] = useState('tarea'); // 'tarea' | 'audiencia'
  const [asignarTab, setAsignarTab] = useState('nueva');
  const [asignarForm, setAsignarForm] = useState({ titulo: '', fecha: '', asignados_a: [] });
  const [asignarUsuarios, setAsignarUsuarios] = useState([]);
  const [asignarAsignaciones, setAsignarAsignaciones] = useState([]);
  const [asignarExistenteId, setAsignarExistenteId] = useState(null);
  const [asignarBusqueda, setAsignarBusqueda] = useState('');
  const [asignarGuardando, setAsignarGuardando] = useState(false);

  // Grupos audiencias
  const [gruposAudienciasColapsados, setGruposAudienciasColapsados] = useState({});
  const [nuevoGrupoAudienciaOpen, setNuevoGrupoAudienciaOpen] = useState(false);
  const [nuevoGrupoAudienciaNombre, setNuevoGrupoAudienciaNombre] = useState('');
  const [renombrandoGrupoAudiencia, setRenombrandoGrupoAudiencia] = useState(null);
  const [renombreAudienciaValor, setRenombreAudienciaValor] = useState('');
  const [formAudienciaGrupoNuevo, setFormAudienciaGrupoNuevo] = useState(false);
  const [formAudienciaGrupoNuevoValor, setFormAudienciaGrupoNuevoValor] = useState('');

  useEffect(() => {
    if (expedienteId) { fetchExpediente(); fetchTareas(); fetchMovimientos(); fetchAudiencias(); fetchNotas(); fetchEstadoProcesal(); fetchVinculados(); fetchPruebas(); }
  }, [expedienteId]);

  // Mantenerse sincronizado cuando una tarea cambia desde otro lugar (Espacio de trabajo, otro drawer, etc.)
  useEffect(() => onTareaChanged(() => { if (expedienteId) fetchTareas(); }), [expedienteId]);

  useEffect(() => {
    if (pruebaDetalleId) fetchPruebaEventos(pruebaDetalleId);
    else setPruebaEventos([]);
  }, [pruebaDetalleId]);

  // Sincronizar grupos de tareas desde DB (agrega al final los grupos nuevos que llegaron del servidor)
  useEffect(() => {
    const gruposDB = [...new Set(tareas.map(t => t.grupo).filter(Boolean))];
    setGruposOrden(prev => {
      const sinGrupoEntry = '__sin_grupo__';
      const nuevos = gruposDB.filter(g => !prev.includes(g));
      const base = nuevos.length ? [...prev, ...nuevos] : prev;
      return base.includes(sinGrupoEntry) ? base : [...base, sinGrupoEntry];
    });
  }, [tareas]);

  // Sincronizar grupos de audiencias desde DB
  useEffect(() => {
    const gruposDB = [...new Set(audiencias.map(a => a.grupo).filter(Boolean))];
    setGruposAudienciasOrden(prev => {
      const nuevos = gruposDB.filter(g => !prev.includes(g));
      return nuevos.length ? [...prev, ...nuevos] : prev;
    });
  }, [audiencias]);

  useEffect(() => {
    supabase.from('tipos_juicio').select('id, nombre').order('nombre').then(({ data }) => setTiposJuicio(data || []));
  }, []);

  async function fetchExpediente() {
    const { data } = await supabase
      .from('expedientes')
      .select('*, expedientes_clientes(cliente_id, clientes(nombre, apellido))')
      .eq('id', expedienteId).single();
    setExpediente(data);
    setLoading(false);
  }

  async function fetchTareas() {
    let { data, error } = await supabase.from('tareas').select('*')
      .eq('expediente_id', expedienteId)
      .eq('eliminado', false)
      .order('orden', { ascending: true, nullsFirst: false })
      .order('created_at', { ascending: true });
    // Fallback si la columna `orden` todavía no existe en la base
    if (error) {
      ({ data } = await supabase.from('tareas').select('*')
        .eq('expediente_id', expedienteId)
        .eq('eliminado', false)
        .order('created_at', { ascending: true }));
    }
    setTareas(data || []);
  }

  async function fetchMovimientos() {
    const { data } = await supabase.from('movimientos').select('*')
      .eq('expediente_id', expedienteId)
      .eq('eliminado', false)
      .order('fecha', { ascending: false });
    setMovimientos(data || []);
  }
  async function fetchAudiencias() {
    let { data, error } = await supabase.from('agenda').select('*').eq('expediente_id', expedienteId)
      .eq('eliminado', false)
      .order('orden', { ascending: true, nullsFirst: false })
      .order('fecha', { ascending: true });
    if (error) {
      ({ data } = await supabase.from('agenda').select('*').eq('expediente_id', expedienteId).eq('eliminado', false).order('fecha', { ascending: true }));
    }
    setAudiencias(data || []);
  }

  async function setEstadoAudiencia(id, estado) {
    setAudiencias(prev => prev.map(a => a.id === id ? { ...a, estado } : a));
    const { error } = await supabase.from('agenda').update({ estado }).eq('id', id);
    if (error) fetchAudiencias();
  }

  async function deleteAudiencia(id) {
    setConfirm({
      titulo: 'Eliminar audiencia',
      mensaje: '¿Eliminar esta audiencia/turno? Esta acción no se puede deshacer.',
      onConfirmar: async () => {
        setConfirm(null);
        setAudiencias(prev => prev.filter(a => a.id !== id));
        await softDelete('agenda', id);
      }
    });
  }

  async function fetchNotas() {
    const { data } = await supabase.from('expedientes_notas').select('*').eq('expediente_id', expedienteId).eq('eliminado', false).order('created_at', { ascending: false });
    setNotas(data || []);
  }

  async function fetchPruebas() {
    const { data: pData } = await supabase.from('expediente_pruebas').select('*')
      .eq('expediente_id', expedienteId).eq('eliminado', false).order('created_at', { ascending: true });
    setPruebas(pData || []);
    // Construir mapa tarea_id/agenda_id → info de prueba para mostrar en listados
    if (pData?.length) {
      const pruebaIds = pData.map(p => p.id);
      const { data: evData } = await supabase.from('prueba_eventos')
        .select('tarea_id, agenda_id, prueba_id')
        .in('prueba_id', pruebaIds);
      const tareaMap = {};
      const audMap = {};
      (evData || []).forEach(ev => {
        const p = pData.find(x => x.id === ev.prueba_id);
        if (p) {
          const cfg = TIPO_PRUEBA[p.tipo] || TIPO_PRUEBA.otro;
          const label = p.nombre || p.descripcion || cfg.label;
          if (ev.tarea_id) tareaMap[ev.tarea_id] = { tipo: p.tipo, label };
          if (ev.agenda_id) audMap[ev.agenda_id] = { tipo: p.tipo, label };
        }
      });
      setTareasPruebaRef(tareaMap);
      setAudienciasPruebaRef(audMap);
    } else {
      setTareasPruebaRef({});
      setAudienciasPruebaRef({});
    }
  }

  async function savePrueba() {
    if (!formPrueba.tipo) return;
    setGuardandoPrueba(true);
    const payload = {
      expediente_id: expedienteId,
      tipo: formPrueba.tipo,
      estado: formPrueba.estado,
      descripcion: formPrueba.descripcion || null,
      nombre: formPrueba.nombre || null,
      parte: formPrueba.parte,
    };
    if (editingPruebaId) {
      await supabase.from('expediente_pruebas').update(payload).eq('id', editingPruebaId);
    } else {
      await supabase.from('expediente_pruebas').insert(payload);
    }
    setGuardandoPrueba(false);
    setModalPruebaOpen(false);
    setEditingPruebaId(null);
    setFormPrueba({ tipo: 'testimonial', estado: 'no_instada', descripcion: '', nombre: '', parte: 'nuestra' });
    fetchPruebas();
    showToast(editingPruebaId ? 'Prueba actualizada ✓' : 'Prueba agregada ✓');
  }

  async function fetchPruebaEventos(pruebaId) {
    const { data } = await supabase.from('prueba_eventos').select('*')
      .eq('prueba_id', pruebaId).eq('eliminado', false).order('fecha', { ascending: true }).order('created_at', { ascending: true });
    setPruebaEventos(data || []);
  }

  async function saveEvento() {
    const esAudiencia = formEvento.tipo === 'audiencia';
    if (!esAudiencia && !formEvento.descripcion.trim()) { showToast('Completá la descripción'); return; }
    if ((formEvento.tipo === 'vencimiento' || esAudiencia) && !formEvento.fecha) { showToast('Completá la fecha'); return; }
    setGuardandoEvento(true);
    const pruebaId = pruebaDetalleId;
    let tareaId = null;
    let agendaId = null;
    if (formEvento.tipo === 'vencimiento') {
      const { data: t, error: tErr } = await supabase.from('tareas').insert({
        titulo: formEvento.descripcion.trim(),
        fecha_vencimiento: formEvento.fecha,
        expediente_id: expedienteId,
        completada: false,
      }).select().single();
      if (tErr) console.error('Error creando tarea:', tErr);
      tareaId = t?.id || null;
      fetchTareas();
    } else if (formEvento.tipo === 'tarea') {
      const { data: t, error: tErr } = await supabase.from('tareas').insert({
        titulo: formEvento.descripcion.trim(),
        fecha_vencimiento: formEvento.fecha || null,
        expediente_id: expedienteId,
        completada: false,
      }).select().single();
      if (tErr) console.error('Error creando tarea:', tErr);
      tareaId = t?.id || null;
      fetchTareas();
    } else if (esAudiencia) {
      const prueba = pruebas.find(x => x.id === pruebaId);
      const cfg = TIPO_PRUEBA[prueba?.tipo] || TIPO_PRUEBA.otro;
      const autoTitulo = `${cfg.label}${prueba?.nombre ? ' de ' + prueba.nombre : ''}`;
      const { data: ag, error: agErr } = await supabase.from('agenda').insert({
        titulo: autoTitulo,
        fecha: formEvento.fecha,
        hora: formEvento.hora || null,
        tipo: 'Audiencia',
        expediente_id: expedienteId,
        estado: 'pendiente',
      }).select().single();
      if (agErr) console.error('Error creando audiencia:', agErr);
      agendaId = ag?.id || null;
      if (ag?.id && formEvento.descripcion.trim()) {
        await supabase.from('agenda_notas').insert({ agenda_id: ag.id, contenido: formEvento.descripcion.trim() });
      }
      fetchAudiencias();
    }
    const { error: evErr } = await supabase.from('prueba_eventos').insert({
      prueba_id: pruebaId,
      tipo: formEvento.tipo,
      descripcion: formEvento.descripcion.trim(),
      fecha: formEvento.fecha || null,
      tarea_id: tareaId,
      agenda_id: agendaId,
    });
    setGuardandoEvento(false);
    if (evErr) {
      console.error('Error registrando evento en prueba:', evErr);
      showToast('Error al registrar el evento: ' + evErr.message);
      return;
    }
    setModalEventoOpen(false);
    setFormEvento({ tipo: 'nota', descripcion: '', fecha: '', hora: '00:00' });
    fetchPruebaEventos(pruebaId);
    fetchPruebas(); // actualiza el mapa de referencias
    showToast('Evento registrado ✓');
  }

  async function deleteEvento(id) {
    await softDelete('prueba_eventos', id);
    fetchPruebaEventos(pruebaDetalleId);
    showToast('Evento eliminado');
  }

  async function deletePrueba(id) {
    setConfirm({
      titulo: 'Eliminar prueba',
      mensaje: '¿Eliminar esta prueba?',
      onConfirmar: async () => {
        setConfirm(null);
        await softDeleteHijos('prueba_eventos', 'prueba_id', id);
        await softDelete('expediente_pruebas', id);
        setPruebaDetalleId(null);
        fetchPruebas();
        showToast('Prueba eliminada');
      }
    });
  }

  async function fetchVinculados() {
    // Obtener el expediente_principal_id del expediente actual
    const { data: exp } = await supabase.from('expedientes').select('expediente_principal_id').eq('id', expedienteId).single();
    if (exp?.expediente_principal_id) {
      const { data: principal } = await supabase.from('expedientes').select('id, caratula, numero').eq('id', exp.expediente_principal_id).single();
      setExpedientePrincipal(principal || null);
    } else {
      setExpedientePrincipal(null);
    }
    const { data: hijos } = await supabase.from('expedientes').select('id, caratula, numero').eq('expediente_principal_id', expedienteId).order('created_at', { ascending: true });
    setIncidentes(hijos || []);
  }

  async function saveNuevoIncidente() {
    if (guardandoIncidente) return;
    if (!formIncidente.caratula.trim()) { showToast('La carátula es obligatoria'); return; }
    setGuardandoIncidente(true);
    const { data: nuevoExp, error } = await supabase.from('expedientes').insert({
      caratula: formIncidente.caratula,
      numero: formIncidente.numero || null,
      fuero: expediente.fuero || null,
      posicion_procesal: expediente.posicion_procesal || 'actor',
      juzgado: expediente.juzgado || null,
      juez: expediente.juez || null,
      secretaria: expediente.secretaria || null,
      actuario: expediente.actuario || null,
      jurisdiccion: expediente.jurisdiccion || null,
      expediente_principal_id: expedienteId,
    }).select('id').single();
    if (error || !nuevoExp) { showToast('Error al crear el incidente'); setGuardandoIncidente(false); return; }
    // Copiar los clientes del principal
    const clienteIds = expediente.expedientes_clientes?.map(ec => ec.cliente_id) || [];
    if (clienteIds.length) {
      await supabase.from('expedientes_clientes').insert(clienteIds.map(id => ({ expediente_id: nuevoExp.id, cliente_id: id })));
    }
    setGuardandoIncidente(false);
    setModalNuevoIncidente(false);
    setFormIncidente({ caratula: '', numero: '' });
    showToast('Incidente creado ✓');
    fetchVinculados();
    onUpdate?.();
  }

  async function fetchEstadoProcesal() {
    const { data: etapas, error } = await supabase
      .from('expediente_etapas')
      .select('*, expediente_requisitos(*)')
      .eq('expediente_id', expedienteId)
      .order('fecha_inicio', { ascending: false });
    if (error) { console.error('fetchEstadoProcesal:', error); return; }
    if (!etapas) return;
    const actual = etapas.find(e => e.es_actual) || null;
    setEtapaActual(actual);
    setHistorialEtapas(etapas.filter(e => !e.es_actual));
    setRequisitosEtapa(actual?.expediente_requisitos?.sort((a, b) => a.orden - b.orden) || []);
  }

  async function fetchEtapasPlantilla(tipoJuicioId) {
    const { data } = await supabase
      .from('etapas_plantilla')
      .select('*, requisitos_plantilla(*)')
      .eq('tipo_juicio_id', tipoJuicioId)
      .order('orden');
    setEtapasPlantilla(data || []);
  }

  async function cambiarEtapa(nombre, etapaPlantillaId, requisitosBase) {
    // Marcar etapa actual como no actual
    if (etapaActual) {
      await supabase.from('expediente_etapas').update({ es_actual: false }).eq('id', etapaActual.id);
    }
    // Crear nueva etapa
    const { data: nuevaEtapa, error: errEtapa } = await supabase
      .from('expediente_etapas')
      .insert({ expediente_id: expedienteId, nombre, etapa_plantilla_id: etapaPlantillaId || null, es_actual: true, fecha_inicio: new Date().toISOString() })
      .select('id').single();
    if (errEtapa) { console.error('cambiarEtapa insert:', errEtapa); showToast('Error al cambiar etapa: ' + errEtapa.message); return; }
    // Insertar requisitos desde plantilla
    if (nuevaEtapa && requisitosBase?.length > 0) {
      const rows = requisitosBase.map((r, i) => ({
        expediente_etapa_id: nuevaEtapa.id,
        texto: r.texto,
        estado: 'pendiente',
        orden: i,
        requisito_plantilla_id: r.id
      }));
      await supabase.from('expediente_requisitos').insert(rows);
    }
    // Sincronizar badge en lista de expedientes
    await supabase.from('expedientes').update({ estado_procesal: nombre }).eq('id', expedienteId);
    setModalCambiarEtapa(false);
    setNuevaEtapaNombre('');
    setEtapaPersonalizada(false);
    await fetchEstadoProcesal();
    if (onUpdate) onUpdate();
  }

  async function updateRequisito(id, changes) {
    await supabase.from('expediente_requisitos').update(changes).eq('id', id);
    await fetchEstadoProcesal();
  }

  function openRequisitoDetalle(r) {
    setFormReqDetalle({
      texto: r.texto,
      estado: r.estado,
      fecha: r.fecha ? r.fecha.split('T')[0] : '',
      fecha_vencimiento: r.fecha_vencimiento ? r.fecha_vencimiento.split('T')[0] : '',
      notas: r.notas || '',
      producida_en: r.producida_en || null,
    });
    setRequisitoDetalleId(r.id);
  }

  async function saveRequisitoDetalle() {
    if (!formReqDetalle.texto.trim()) return;
    setGuardandoReq(true);
    const eraProducida = requisitosEtapa.find(x => x.id === requisitoDetalleId)?.estado === 'completada';
    const ahoraProducida = formReqDetalle.estado === 'completada';
    const producida_en = ahoraProducida && !eraProducida ? new Date().toISOString() : ahoraProducida ? formReqDetalle.producida_en : null;
    await supabase.from('expediente_requisitos').update({
      texto: formReqDetalle.texto.trim(),
      estado: formReqDetalle.estado,
      fecha: formReqDetalle.fecha || null,
      fecha_vencimiento: formReqDetalle.fecha_vencimiento || null,
      notas: formReqDetalle.notas.trim() || null,
      producida_en,
    }).eq('id', requisitoDetalleId);
    setRequisitosEtapa(prev => prev.map(x => x.id === requisitoDetalleId
      ? { ...x, texto: formReqDetalle.texto.trim(), estado: formReqDetalle.estado, fecha: formReqDetalle.fecha || null, fecha_vencimiento: formReqDetalle.fecha_vencimiento || null, notas: formReqDetalle.notas.trim() || null, producida_en }
      : x
    ));
    setGuardandoReq(false);
    setRequisitoDetalleId(null);
  }

  async function toggleRequisito(r) {
    if (togglingReq.has(r.id)) return;
    const nuevoEstado = r.estado === 'completada' ? 'pendiente' : 'completada';
    const producida_en = nuevoEstado === 'completada' ? new Date().toISOString() : null;
    setRequisitosEtapa(prev => prev.map(x => x.id === r.id ? { ...x, estado: nuevoEstado, producida_en } : x));
    setTogglingReq(prev => new Set([...prev, r.id]));
    await supabase.from('expediente_requisitos').update({ estado: nuevoEstado, producida_en }).eq('id', r.id);
    setTogglingReq(prev => { const s = new Set(prev); s.delete(r.id); return s; });
  }

  async function addRequisito() {
    if (!nuevoReqTexto.trim() || !etapaActual) return;
    const orden = requisitosEtapa.length;
    await supabase.from('expediente_requisitos').insert({
      expediente_etapa_id: etapaActual.id,
      texto: nuevoReqTexto.trim(),
      estado: 'pendiente',
      orden
    });
    setNuevoReqTexto('');
    setModalNuevoReq(false);
    await fetchEstadoProcesal();
  }

  async function deleteRequisito(id) {
    await supabase.from('expediente_requisitos').delete().eq('id', id);
    await fetchEstadoProcesal();
  }

  async function addNota() {
    if (!nuevaNota.trim()) return;
    const { error } = await supabase.from('expedientes_notas').insert({ expediente_id: expedienteId, contenido: nuevaNota.trim() });
    if (error) { showToast('Error al guardar la nota'); return; }
    setNuevaNota('');
    fetchNotas();
    showToast('Nota guardada ✓');
  }

  async function deleteNota(id) {
    await softDelete('expedientes_notas', id);
    setNotas(ns => ns.filter(n => n.id !== id));
  }

  function showToast(msg) { setToast(msg); setTimeout(() => setToast(null), 3000); }

  async function buscarExpedientesPrincipales(texto) {
    let query = supabase.from('expedientes')
      .select('id, caratula, numero')
      .neq('id', expedienteId)
      .is('expediente_principal_id', null)
      .order('caratula')
      .limit(12);
    if (texto.trim()) {
      query = query.or(`caratula.ilike.%${texto}%,numero.ilike.%${texto}%`);
    }
    const { data } = await query;
    setResultadosConvertir(data || []);
  }

  async function desvinculardePrincipal() {
    await supabase.from('expedientes').update({ expediente_principal_id: null }).eq('id', expedienteId);
    showToast('Expediente desvinculado ✓');
    fetchVinculados();
    fetchExpediente();
    onUpdate?.();
  }

  async function fetchTodosClientes() {
    const { data } = await supabase.from('clientes').select('id, nombre, apellido').eq('eliminado', false).order('apellido');
    setTodosClientes(data || []);
  }

  function openEditarExpediente() {
    setBusquedaConvertir('');
    setResultadosConvertir([]);
    setPrincipalConvertir(null);
    setDropdownConvertirOpen(false);
    setBusquedaClienteEdit('');
    setFormEditExp({
      caratula: expediente.caratula || '',
      numero: expediente.numero || '',
      fuero: expediente.fuero || '',
      posicion_procesal: expediente.posicion_procesal || 'actor',
      juzgado: expediente.juzgado || '',
      juez: expediente.juez || '',
      secretaria: expediente.secretaria || '',
      jurisdiccion: expediente.jurisdiccion || '',
      tipo_juicio_id: expediente.tipo_juicio_id || '',
      fecha_inicio: expediente.fecha_inicio || '',
      fecha_intervencion: expediente.fecha_intervencion || '',
      parte_contraria: expediente.parte_contraria || '',
      letrado_contrario: expediente.letrado_contrario || '',
      cliente_ids: expediente.expedientes_clientes?.map(ec => ec.cliente_id) || [],
      prueba_habilitada: expediente.prueba_habilitada ?? true,
    });
    if (todosClientes.length === 0) fetchTodosClientes();
    setModalEditarExp(true);
  }

  async function saveExpediente() {
    if (!formEditExp.caratula.trim()) { showToast('La carátula es obligatoria'); return; }
    setGuardandoExp(true);
    const updateData = {
      caratula: formEditExp.caratula,
      numero: formEditExp.numero || null,
      fuero: formEditExp.fuero || null,
      posicion_procesal: formEditExp.posicion_procesal,
      juzgado: formEditExp.juzgado || null,
      juez: formEditExp.juez || null,
      secretaria: formEditExp.secretaria || null,
      jurisdiccion: formEditExp.jurisdiccion || null,
      tipo_juicio_id: formEditExp.tipo_juicio_id || null,
      fecha_inicio: formEditExp.fecha_inicio || null,
      fecha_intervencion: formEditExp.fecha_intervencion || null,
      parte_contraria: formEditExp.parte_contraria || null,
      letrado_contrario: formEditExp.letrado_contrario || null,
      prueba_habilitada: formEditExp.prueba_habilitada ?? true,
    };
    if (principalConvertir) {
      updateData.expediente_principal_id = principalConvertir.id;
    }
    await supabase.from('expedientes').update(updateData).eq('id', expedienteId);
    // Sincronizar clientes vinculados
    await supabase.from('expedientes_clientes').delete().eq('expediente_id', expedienteId);
    if (formEditExp.cliente_ids?.length > 0) {
      await supabase.from('expedientes_clientes').insert(
        formEditExp.cliente_ids.map(cid => ({ expediente_id: expedienteId, cliente_id: cid }))
      );
    }
    setGuardandoExp(false);
    setModalEditarExp(false);
    const msg = principalConvertir ? 'Convertido en incidente ✓' : 'Expediente actualizado ✓';
    showToast(msg);
    setPrincipalConvertir(null);
    fetchExpediente();
  }

  async function deleteExpediente() {
    setConfirm({
      titulo: 'Eliminar expediente',
      mensaje: '¿Eliminar este expediente? Esta acción no se puede deshacer.',
      onConfirmar: async () => {
        setConfirm(null);
        await Promise.all([
          softDeleteHijos('tareas', 'expediente_id', expedienteId),
          softDeleteHijos('agenda', 'expediente_id', expedienteId),
          softDeleteHijos('movimientos', 'expediente_id', expedienteId),
          softDeleteHijos('expedientes_notas', 'expediente_id', expedienteId),
          softDeleteHijos('expediente_pruebas', 'expediente_id', expedienteId),
        ]);
        await softDelete('expedientes', expedienteId);
        emitEntidadChanged({ tipo: 'expediente', id: expedienteId, eliminado: true });
        onUpdate?.();
        onClose();
      }
    });
  }

  function openNuevaTarea(grupoInicial = '') {
    setEditingTareaId(null);
    setFormTarea({ titulo: '', descripcion: '', fecha: '', fecha_vencimiento: '', prioridad: 'normal', fijada: false, grupo: grupoInicial });
    setFormTareaGrupoNuevo(false);
    setFormTareaGrupoNuevoValor('');
    setModalTareaOpen(true);
  }

  function openEditTarea(t) {
    setEditingTareaId(t.id);
    setFormTarea({
      titulo: t.titulo || '', descripcion: t.descripcion || '',
      fecha: t.fecha || '', fecha_vencimiento: t.fecha_vencimiento || '',
      prioridad: t.prioridad || 'normal', fijada: t.fijada || false, grupo: t.grupo || ''
    });
    setFormTareaGrupoNuevo(false);
    setFormTareaGrupoNuevoValor('');
    setNuevaNotaTarea('');
    fetchNotasTarea(t.id);
    setModalTareaOpen(true);
  }

  async function fetchNotasTarea(tareaId) {
    const { data } = await supabase.from('tareas_notas').select('*').eq('tarea_id', tareaId).eq('eliminado', false).order('created_at', { ascending: false });
    setNotasTarea(data || []);
  }

  async function addNotaTarea() {
    if (!nuevaNotaTarea.trim() || !editingTareaId) return;
    await supabase.from('tareas_notas').insert({ tarea_id: editingTareaId, contenido: nuevaNotaTarea.trim() });
    setNuevaNotaTarea('');
    fetchNotasTarea(editingTareaId);
  }

  async function deleteNotaTarea(id) {
    await softDelete('tareas_notas', id);
    setNotasTarea(ns => ns.filter(n => n.id !== id));
  }

  async function saveTarea() {
    if (guardandoTarea) return;
    if (!formTarea.titulo.trim()) { showToast('El título es obligatorio'); return; }
    setGuardandoTarea(true);
    const grupoFinal = formTareaGrupoNuevo ? (formTareaGrupoNuevoValor.trim() || null) : (formTarea.grupo || null);
    const tareaData = {
      titulo: formTarea.titulo, descripcion: formTarea.descripcion,
      fecha: formTarea.fecha || null, fecha_vencimiento: formTarea.fecha_vencimiento || null,
      prioridad: formTarea.prioridad, fijada: formTarea.fijada,
      expediente_id: expedienteId, completada: false, grupo: grupoFinal
    };
    if (editingTareaId) {
      await supabase.from('tareas').update(tareaData).eq('id', editingTareaId);
      await supabase.from('asignacion_items')
        .update({ descripcion: formTarea.titulo })
        .eq('tarea_id', editingTareaId);
    } else {
      await supabase.from('tareas').insert(tareaData);
    }
    setGuardandoTarea(false);
    showToast(editingTareaId ? 'Tarea actualizada ✓' : 'Tarea creada ✓');
    setModalTareaOpen(false);
    fetchTareas();
  }

  async function saveAudiencia() {
    if (!formAudiencia.titulo.trim() && !formAudiencia.fecha) { setAudienciaError('Completá el título y la fecha antes de guardar.'); return; }
    if (!formAudiencia.titulo.trim()) { setAudienciaError('El título es obligatorio.'); return; }
    if (!formAudiencia.fecha) { setAudienciaError('La fecha es obligatoria.'); return; }
    setAudienciaError('');
    const grupoFinal = formAudienciaGrupoNuevo ? (formAudienciaGrupoNuevoValor.trim() || null) : (formAudiencia.grupo || null);
    const payload = { ...formAudiencia, hora: formAudiencia.hora || null, grupo: grupoFinal };
    if (editingAudienciaId) {
      await supabase.from('agenda').update(payload).eq('id', editingAudienciaId);
      await supabase.from('asignacion_items').update({ descripcion: formAudiencia.titulo }).eq('agenda_id', editingAudienciaId);
      showToast('Evento actualizado ✓');
    } else {
      await supabase.from('agenda').insert({ ...payload, expediente_id: expedienteId });
      showToast('Evento agendado ✓');
    }
    setModalAudienciaOpen(false);
    setEditingAudienciaId(null);
    setFormAudiencia({ titulo: '', tipo: 'Audiencia', fecha: '', hora: '00:00', notas: '', estado: 'pendiente', grupo: '' });
    setFormAudienciaGrupoNuevo(false);
    setFormAudienciaGrupoNuevoValor('');
    fetchAudiencias();
  }

  async function renombrarGrupo(viejo, nuevo) {
    if (!nuevo.trim() || nuevo === viejo) return;
    await supabase.from('tareas').update({ grupo: nuevo.trim() }).eq('expediente_id', expedienteId).eq('grupo', viejo);
    setGruposOrden(prev => prev.map(g => g === viejo ? nuevo.trim() : g));
    setRenombrandoGrupo(null);
    setRenombreValor('');
    fetchTareas();
  }

  async function eliminarGrupo(nombre) {
    const esLocal = !tareas.some(t => t.grupo === nombre);
    if (esLocal) {
      setGruposOrden(prev => prev.filter(g => g !== nombre));
      return;
    }
    setConfirm({
      titulo: 'Eliminar grupo',
      mensaje: `¿Eliminar el grupo "${nombre}"? Las tareas quedarán sin grupo.`,
      onConfirmar: async () => {
        setConfirm(null);
        await supabase.from('tareas').update({ grupo: null }).eq('expediente_id', expedienteId).eq('grupo', nombre);
        setGruposOrden(prev => prev.filter(g => g !== nombre));
        fetchTareas();
      }
    });
  }

  async function renombrarGrupoAudiencia(viejo, nuevo) {
    if (!nuevo.trim() || nuevo === viejo) return;
    await supabase.from('agenda').update({ grupo: nuevo.trim() }).eq('expediente_id', expedienteId).eq('grupo', viejo);
    setGruposAudienciasOrden(prev => prev.map(g => g === viejo ? nuevo.trim() : g));
    setRenombrandoGrupoAudiencia(null);
    setRenombreAudienciaValor('');
    fetchAudiencias();
  }

  async function eliminarGrupoAudiencia(nombre) {
    const esLocal = !audiencias.some(a => a.grupo === nombre);
    if (esLocal) {
      setGruposAudienciasOrden(prev => prev.filter(g => g !== nombre));
      return;
    }
    setConfirm({
      titulo: 'Eliminar grupo',
      mensaje: `¿Eliminar el grupo "${nombre}"? Las audiencias quedarán sin grupo.`,
      onConfirmar: async () => {
        setConfirm(null);
        await supabase.from('agenda').update({ grupo: null }).eq('expediente_id', expedienteId).eq('grupo', nombre);
        setGruposAudienciasOrden(prev => prev.filter(g => g !== nombre));
        fetchAudiencias();
      }
    });
  }

  function openModalAsignar(items, titulo, tipo = 'tarea') {
    setAsignarItems(items);
    setAsignarTitulo(titulo);
    setAsignarTipo(tipo);
    setAsignarTab('nueva');
    setAsignarForm({ titulo, fecha: new Date().toISOString().split('T')[0], asignados_a: [] });
    setAsignarExistenteId(null);
    setAsignarBusqueda('');
    setModalAsignarOpen(true);
    fetchAsignarUsuarios();
    fetchAsignarAsignaciones();
  }

  async function fetchAsignarUsuarios() {
    const { data } = await supabase.from('profiles').select('id, nombre, rol').order('nombre');
    if (!data || data.length === 0) {
      const { data: { session } } = await supabase.auth.getSession();
      setAsignarUsuarios(session ? [{ id: session.user.id, nombre: session.user.email?.split('@')[0] || 'Mi usuario' }] : []);
    } else {
      setAsignarUsuarios(data.map(u => ({ ...u, nombre: u.nombre || u.rol || 'Sin nombre' })));
    }
  }

  async function fetchAsignarAsignaciones() {
    const { data } = await supabase.from('asignaciones').select('id, titulo, fecha').eq('eliminado', false).order('fecha', { ascending: false }).limit(80);
    setAsignarAsignaciones(data || []);
  }

  async function guardarAsignar() {
    setAsignarGuardando(true);
    const { data: { session } } = await supabase.auth.getSession();
    const userId = session?.user?.id;
    const esAudiencia = asignarTipo === 'audiencia';

    if (asignarTab === 'nueva') {
      if (!asignarForm.titulo.trim() || !asignarForm.fecha || asignarForm.asignados_a.length === 0) {
        showToast('Completá título, fecha y al menos un usuario');
        setAsignarGuardando(false);
        return;
      }
      const { data: nueva, error } = await supabase.from('asignaciones').insert({
        titulo: asignarForm.titulo.trim(), fecha: asignarForm.fecha, creado_por: userId,
      }).select('id').single();
      if (error) { showToast('Error: ' + error.message); setAsignarGuardando(false); return; }
      await supabase.from('asignacion_usuarios').insert(
        asignarForm.asignados_a.map(uid => ({ asignacion_id: nueva.id, usuario_id: uid }))
      );
      await supabase.from('asignacion_items').insert(
        asignarItems.map((t, i) => ({
          asignacion_id: nueva.id, descripcion: t.titulo,
          ...(esAudiencia ? { agenda_id: t.id } : { tarea_id: t.id }),
          orden: i
        }))
      );
      showToast('Asignación creada ✓');
    } else {
      if (!asignarExistenteId) { showToast('Seleccioná una asignación'); setAsignarGuardando(false); return; }
      const idField = esAudiencia ? 'agenda_id' : 'tarea_id';
      const { data: existingItems } = await supabase.from('asignacion_items').select(`${idField}, orden`).eq('asignacion_id', asignarExistenteId);
      const existingIds = new Set((existingItems || []).map(i => i[idField]).filter(Boolean));
      const maxOrden = existingItems?.length ? Math.max(...existingItems.map(i => i.orden)) + 1 : 0;
      const newItems = asignarItems
        .filter(t => !existingIds.has(t.id))
        .map((t, i) => ({
          asignacion_id: asignarExistenteId, descripcion: t.titulo,
          ...(esAudiencia ? { agenda_id: t.id } : { tarea_id: t.id }),
          orden: maxOrden + i
        }));
      if (newItems.length > 0) await supabase.from('asignacion_items').insert(newItems);
      showToast('Tareas agregadas ✓');
    }

    setAsignarGuardando(false);
    setModalAsignarOpen(false);
  }

  function crearGrupoInline() {
    if (!nuevoGrupoNombre.trim()) return;
    const nombre = nuevoGrupoNombre.trim();
    setGruposOrden(prev => [nombre, ...prev.filter(g => g !== nombre)]); // prepend, sin duplicar
    setNuevoGrupoInlineOpen(false);
    setNuevoGrupoNombre('');
  }

  function crearGrupoAudienciaInline() {
    if (!nuevoGrupoAudienciaNombre.trim()) return;
    const nombre = nuevoGrupoAudienciaNombre.trim();
    setGruposAudienciasOrden(prev => [nombre, ...prev.filter(g => g !== nombre)]); // prepend
    setNuevoGrupoAudienciaOpen(false);
    setNuevoGrupoAudienciaNombre('');
  }

  async function toggleTarea(tarea) {
    if (toggling.has(tarea.id)) return;
    const completada = !tarea.completada;
    const completada_en = completada ? new Date().toISOString() : null;
    // Actualización inmediata en la UI
    setTareas(prev => prev.map(t => t.id === tarea.id ? { ...t, completada, completada_en } : t));
    // Sincroniza con Supabase en segundo plano
    setToggling(prev => new Set([...prev, tarea.id]));
    await supabase.from('tareas').update({ completada, completada_en }).eq('id', tarea.id);
    setToggling(prev => { const s = new Set(prev); s.delete(tarea.id); return s; });
    emitTareaChanged({ id: tarea.id, completada });
  }

  async function toggleFijada(tarea) {
    await supabase.from('tareas').update({ fijada: !tarea.fijada }).eq('id', tarea.id);
    fetchTareas();
  }

  async function deleteTarea(id) {
    setConfirm({
      titulo: 'Eliminar tarea',
      mensaje: '¿Eliminar esta tarea?',
      onConfirmar: async () => {
        setConfirm(null);
        await softDeleteHijos('tareas_notas', 'tarea_id', id);
        await softDelete('tareas', id);
        fetchTareas();
        emitTareaChanged({ id, eliminado: true });
      }
    });
  }

  async function descartarTarea(id) {
    await supabase.from('tareas').update({ descartada: true, completada: false, descartada_en: new Date().toISOString() }).eq('id', id);
    fetchTareas();
    emitTareaChanged({ id, descartada: true });
  }

  async function reactivarTarea(id) {
    await supabase.from('tareas').update({ descartada: false, descartada_en: null }).eq('id', id);
    emitTareaChanged({ id, descartada: false });
    fetchTareas();
  }

  async function saveMovimiento() {
    if (!formMov.descripcion.trim()) { showToast('La descripción es obligatoria'); return; }
    await supabase.from('movimientos').insert({
      descripcion: formMov.descripcion,
      fecha: formMov.fecha || new Date().toISOString().split('T')[0],
      expediente_id: expedienteId
    });
    await supabase.from('expedientes').update({
      fecha_ultimo_movimiento: formMov.fecha || new Date().toISOString().split('T')[0]
    }).eq('id', expedienteId);
    showToast('Movimiento registrado ✓');
    setModalMovOpen(false);
    setFormMov({ descripcion: '', fecha: '' });
    fetchMovimientos();
    fetchExpediente();
    if (onUpdate) onUpdate();
  }

  async function deleteMovimiento(id) {
    setConfirm({
      titulo: 'Eliminar movimiento',
      mensaje: '¿Eliminar este movimiento?',
      onConfirmar: async () => {
        setConfirm(null);
        await softDelete('movimientos', id);
        fetchMovimientos();
      }
    });
  }

  const formatDate = (d) => d ? new Date(d + 'T12:00:00').toLocaleDateString('es-AR') : '—';
  const today = new Date().toISOString().split('T')[0];
  const tareasPendientes = tareas.filter(t => !t.completada && !t.descartada);
  const tareasCompletadas = tareas.filter(t => t.completada && !t.descartada);
  const tareasDescartadas = tareas.filter(t => t.descartada);

  const prioridadColor = (p) => ({ urgente: 'var(--red)', 'muy importante': '#f59e0b', normal: 'var(--blue)', baja: 'var(--text4)' }[p] || 'var(--blue)');
  // Grupos: los del array ordenado que tienen tareas pendientes O son locales (sin tareas aún)
  const grupos = gruposOrden.filter(g =>
    g !== '__sin_grupo__' && (tareasPendientes.some(t => t.grupo === g) || !tareas.some(t => t.grupo === g))
  );
  // ───────────────────── DnD de tareas (@dnd-kit) ─────────────────────
  // Tokens: tareas = `t:<id>`, grupos = `g:<nombre>`. Contenedor `__top__` = nivel superior.
  const tareasPendientesOrden = [...tareasPendientes].sort((a, b) => (a.orden ?? 1e9) - (b.orden ?? 1e9));
  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 4 } }));

  function buildContenedores() {
    const ordenTop = [];
    const grupos = {};
    const placed = new Set();
    for (const t of tareasPendientesOrden) {
      if (t.grupo) {
        if (!grupos[t.grupo]) grupos[t.grupo] = [];
        grupos[t.grupo].push('t:' + t.id);
        if (!placed.has('g:' + t.grupo)) { placed.add('g:' + t.grupo); ordenTop.push('g:' + t.grupo); }
      } else {
        ordenTop.push('t:' + t.id);
      }
    }
    // Grupos locales vacíos (sin tareas todavía) — van al principio, en orden de gruposOrden
    const vacios = gruposOrden
      .filter(g => g !== '__sin_grupo__' && !grupos[g] && !tareas.some(t => t.grupo === g))
      .map(g => { grupos[g] = []; return 'g:' + g; });
    ordenTop.unshift(...vacios);
    return { ordenTop, grupos };
  }

  const vista = contenedoresDrag || buildContenedores();

  function findContenedor(token, c) {
    if (token.startsWith('g:')) return '__top__';
    if (c.ordenTop.includes(token)) return '__top__';
    for (const nombre in c.grupos) if (c.grupos[nombre].includes(token)) return 'g:' + nombre;
    return null;
  }

  function handleDndStart({ active }) {
    const c = buildContenedores();
    contenedoresRef.current = c;
    setContenedoresDrag(c);
    setActiveDragId(active.id);
  }

  function handleDndOver({ active, over }) {
    if (!over) return;
    const activeId = active.id;
    const overId = over.id;
    if (activeId.startsWith('g:')) return; // los grupos se reordenan en dragEnd
    const c = contenedoresRef.current;
    if (!c) return;
    const desde = findContenedor(activeId, c);
    let hacia = overId.startsWith('g:') ? overId : findContenedor(overId, c);
    if (!desde || !hacia || desde === hacia) return;
    const next = { ordenTop: [...c.ordenTop], grupos: {} };
    for (const k in c.grupos) next.grupos[k] = [...c.grupos[k]];
    // sacar del origen
    if (desde === '__top__') { const i = next.ordenTop.indexOf(activeId); if (i >= 0) next.ordenTop.splice(i, 1); }
    else { const arr = next.grupos[desde.slice(2)]; const i = arr.indexOf(activeId); if (i >= 0) arr.splice(i, 1); }
    // meter en destino
    if (hacia === '__top__') {
      const i = next.ordenTop.indexOf(overId);
      next.ordenTop.splice(i >= 0 ? i : next.ordenTop.length, 0, activeId);
    } else {
      const arr = next.grupos[hacia.slice(2)];
      const i = arr.indexOf(overId);
      arr.splice(i >= 0 ? i : arr.length, 0, activeId);
    }
    contenedoresRef.current = next;
    setContenedoresDrag(next);
  }

  function handleDndEnd({ active, over }) {
    const c = contenedoresRef.current;
    const activeId = active.id;
    if (c && over) {
      const overId = over.id;
      const next = { ordenTop: [...c.ordenTop], grupos: {} };
      for (const k in c.grupos) next.grupos[k] = [...c.grupos[k]];
      if (activeId.startsWith('g:')) {
        // reordenar grupo dentro del nivel superior
        const from = next.ordenTop.indexOf(activeId);
        let destinoToken = overId;
        if (!next.ordenTop.includes(destinoToken)) destinoToken = findContenedor(overId, next) === '__top__' ? overId : null;
        const to = destinoToken ? next.ordenTop.indexOf(destinoToken) : -1;
        if (from >= 0 && to >= 0) next.ordenTop = arrayMove(next.ordenTop, from, to);
      } else {
        const cont = findContenedor(activeId, next);
        const arr = cont === '__top__' ? next.ordenTop : next.grupos[cont.slice(2)];
        const from = arr.indexOf(activeId);
        const to = arr.indexOf(overId);
        if (from >= 0 && to >= 0) {
          const moved = arrayMove(arr, from, to);
          if (cont === '__top__') next.ordenTop = moved; else next.grupos[cont.slice(2)] = moved;
        }
      }
      persistirOrden(next);
    }
    contenedoresRef.current = null;
    setContenedoresDrag(null);
    setActiveDragId(null);
  }

  function persistirOrden(c) {
    const flat = [];
    const ordenGrupos = [];
    for (const token of c.ordenTop) {
      if (token.startsWith('t:')) {
        flat.push({ id: token.slice(2), grupo: null });
      } else {
        const nombre = token.slice(2);
        ordenGrupos.push(nombre);
        for (const mt of (c.grupos[nombre] || [])) flat.push({ id: mt.slice(2), grupo: nombre });
      }
    }
    const updates = flat.map((f, i) => ({ id: f.id, grupo: f.grupo, orden: i }));
    const byId = Object.fromEntries(updates.map(u => [u.id, u]));
    setTareas(prev => prev
      .map(t => byId[t.id] ? { ...t, grupo: byId[t.id].grupo, orden: byId[t.id].orden } : t)
      .sort((a, b) => (a.orden ?? 1e9) - (b.orden ?? 1e9))
    );
    setGruposOrden(prev => {
      const resto = prev.filter(g => !ordenGrupos.includes(g) && g !== '__sin_grupo__');
      return [...ordenGrupos, ...resto, '__sin_grupo__'];
    });
    Promise.all(updates.map(u => supabase.from('tareas').update({ grupo: u.grupo, orden: u.orden }).eq('id', u.id)))
      .catch(() => fetchTareas());
  }

  const colisionDnd = (args) => {
    const pointer = pointerWithin(args);
    if (pointer.length > 0) return pointer;
    return rectIntersection(args);
  };

  // ───────────────────── DnD de audiencias (@dnd-kit) ─────────────────────
  const audienciasVisibles = audiencias.filter(a => a.estado !== 'realizado' && a.estado !== 'cancelado');
  const audienciasVisiblesOrden = [...audienciasVisibles].sort((a, b) => (a.orden ?? 1e9) - (b.orden ?? 1e9));

  function buildContenedoresAud() {
    const ordenTop = [];
    const grupos = {};
    const placed = new Set();
    for (const a of audienciasVisiblesOrden) {
      if (a.grupo) {
        if (!grupos[a.grupo]) grupos[a.grupo] = [];
        grupos[a.grupo].push('a:' + a.id);
        if (!placed.has('g:' + a.grupo)) { placed.add('g:' + a.grupo); ordenTop.push('g:' + a.grupo); }
      } else {
        ordenTop.push('a:' + a.id);
      }
    }
    // Grupos locales vacíos — van al principio, en orden de gruposAudienciasOrden
    const vacios = gruposAudienciasOrden
      .filter(g => g !== '__sin_grupo__' && !grupos[g] && !audiencias.some(a => a.grupo === g))
      .map(g => { grupos[g] = []; return 'g:' + g; });
    ordenTop.unshift(...vacios);
    return { ordenTop, grupos };
  }

  const vistaAud = contenedoresAudDrag || buildContenedoresAud();

  function findContenedorAud(token, c) {
    if (token.startsWith('g:')) return '__top__';
    if (c.ordenTop.includes(token)) return '__top__';
    for (const nombre in c.grupos) if (c.grupos[nombre].includes(token)) return 'g:' + nombre;
    return null;
  }

  function handleDndAudStart({ active }) {
    const c = buildContenedoresAud();
    contenedoresAudRef.current = c;
    setContenedoresAudDrag(c);
    setActiveDragAudId(active.id);
  }

  function handleDndAudOver({ active, over }) {
    if (!over) return;
    const activeId = active.id;
    const overId = over.id;
    if (activeId.startsWith('g:')) return;
    const c = contenedoresAudRef.current;
    if (!c) return;
    const desde = findContenedorAud(activeId, c);
    let hacia = overId.startsWith('g:') ? overId : findContenedorAud(overId, c);
    if (!desde || !hacia || desde === hacia) return;
    const next = { ordenTop: [...c.ordenTop], grupos: {} };
    for (const k in c.grupos) next.grupos[k] = [...c.grupos[k]];
    if (desde === '__top__') { const i = next.ordenTop.indexOf(activeId); if (i >= 0) next.ordenTop.splice(i, 1); }
    else { const arr = next.grupos[desde.slice(2)]; const i = arr.indexOf(activeId); if (i >= 0) arr.splice(i, 1); }
    if (hacia === '__top__') {
      const i = next.ordenTop.indexOf(overId);
      next.ordenTop.splice(i >= 0 ? i : next.ordenTop.length, 0, activeId);
    } else {
      const arr = next.grupos[hacia.slice(2)];
      const i = arr.indexOf(overId);
      arr.splice(i >= 0 ? i : arr.length, 0, activeId);
    }
    contenedoresAudRef.current = next;
    setContenedoresAudDrag(next);
  }

  function handleDndAudEnd({ active, over }) {
    const c = contenedoresAudRef.current;
    const activeId = active.id;
    if (c && over) {
      const overId = over.id;
      const next = { ordenTop: [...c.ordenTop], grupos: {} };
      for (const k in c.grupos) next.grupos[k] = [...c.grupos[k]];
      if (activeId.startsWith('g:')) {
        const from = next.ordenTop.indexOf(activeId);
        let destinoToken = overId;
        if (!next.ordenTop.includes(destinoToken)) destinoToken = findContenedorAud(overId, next) === '__top__' ? overId : null;
        const to = destinoToken ? next.ordenTop.indexOf(destinoToken) : -1;
        if (from >= 0 && to >= 0) next.ordenTop = arrayMove(next.ordenTop, from, to);
      } else {
        const cont = findContenedorAud(activeId, next);
        const arr = cont === '__top__' ? next.ordenTop : next.grupos[cont.slice(2)];
        const from = arr.indexOf(activeId);
        const to = arr.indexOf(overId);
        if (from >= 0 && to >= 0) {
          const moved = arrayMove(arr, from, to);
          if (cont === '__top__') next.ordenTop = moved; else next.grupos[cont.slice(2)] = moved;
        }
      }
      persistirOrdenAud(next);
    }
    contenedoresAudRef.current = null;
    setContenedoresAudDrag(null);
    setActiveDragAudId(null);
  }

  function persistirOrdenAud(c) {
    const flat = [];
    const ordenGrupos = [];
    for (const token of c.ordenTop) {
      if (token.startsWith('a:')) {
        flat.push({ id: token.slice(2), grupo: null });
      } else {
        const nombre = token.slice(2);
        ordenGrupos.push(nombre);
        for (const mt of (c.grupos[nombre] || [])) flat.push({ id: mt.slice(2), grupo: nombre });
      }
    }
    const updates = flat.map((f, i) => ({ id: f.id, grupo: f.grupo, orden: i }));
    const byId = Object.fromEntries(updates.map(u => [u.id, u]));
    setAudiencias(prev => prev
      .map(a => byId[a.id] ? { ...a, grupo: byId[a.id].grupo, orden: byId[a.id].orden } : a)
      .sort((a, b) => (a.orden ?? 1e9) - (b.orden ?? 1e9))
    );
    setGruposAudienciasOrden(prev => {
      const resto = prev.filter(g => !ordenGrupos.includes(g) && g !== '__sin_grupo__');
      return [...ordenGrupos, ...resto, '__sin_grupo__'];
    });
    Promise.all(updates.map(u => supabase.from('agenda').update({ grupo: u.grupo, orden: u.orden }).eq('id', u.id)))
      .catch(() => fetchAudiencias());
  }

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: 'var(--text4)' }}>
      Cargando...
    </div>
  );

  if (!expediente) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: 'var(--text4)' }}>
      No encontrado
    </div>
  );

  return (
    <>
      {/* DRAWER HEADER */}
      <div className="drawer-header">
        {backLabel && (
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--blue)', fontSize: 12, cursor: 'pointer', padding: '0 0 10px 0', display: 'block' }}>
            {backLabel}
          </button>
        )}
        <div className="drawer-header-top">
          <div style={{ flex: 1 }}>
            <div className="drawer-num">{expediente.numero || 'S/N'} · {expediente.fuero || 'Sin fuero'}</div>
            <div className="drawer-title">{expediente.caratula}</div>
            <div className="drawer-badges">
              {expediente.fuero && <span className="badge badge-blue">{expediente.fuero}</span>}
              {etapaActual && <span className="badge badge-gray">{etapaActual.nombre}</span>}
              {expediente.posicion_procesal && (
                <span className={`badge ${expediente.posicion_procesal === 'actor' ? 'badge-green' : 'badge-amber'}`}>
                  {expediente.posicion_procesal}
                </span>
              )}
              {expediente.expedientes_clientes?.map(ec => (
                <span
                  key={ec.cliente_id}
                  className="badge badge-gray"
                  onClick={() => ec.cliente_id && setVerCliente(ec.cliente_id)}
                  style={{ cursor: ec.cliente_id ? 'pointer' : 'default' }}
                >
                  {ec.clientes?.nombre} {ec.clientes?.apellido}
                </span>
              ))}
            </div>
          </div>
          <button className="drawer-close" onClick={onClose}>✕</button>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
          <button className="btn btn-primary" onClick={openEditarExpediente} style={{ fontSize: 11, padding: '6px 14px', letterSpacing: 0.5 }}>
            EDITAR EXPEDIENTE
          </button>
        </div>
      </div>

      {/* TABS */}
      <div className="drawer-tabs">
        {[
          { id: 'tareas', label: `Tareas (${tareasPendientes.length})` },
          { id: 'audiencias', label: 'Audiencias', sub: `y Turnos (${audiencias.filter(a => (a.fecha || '') >= new Date().toISOString().split('T')[0]).length})` },
          { id: 'estado_procesal', label: 'Estado Procesal', sub: 'y Movimientos' },
          ...(expediente?.prueba_habilitada !== false ? [{ id: 'prueba', label: `Prueba (${pruebas.length})` }] : []),
          { id: 'ficha', label: 'Ficha y', sub: `notas (${notas.length})` },
        ].map(tab => (
          <div key={tab.id} className={`drawer-tab ${tabActiva === tab.id ? 'active' : ''}`} onClick={() => setTabActiva(tab.id)}>
            <div>{tab.label}</div>
            {tab.sub && <div style={{ paddingLeft: 6 }}>{tab.sub}</div>}
          </div>
        ))}
      </div>

      {/* BODY */}
      <div className="drawer-body">

        {/* TAB FICHA Y NOTAS */}
        {tabActiva === 'ficha' && (
          <div>

            {/* EXPEDIENTES VINCULADOS */}
            <div style={{ marginBottom: 16, background: 'var(--surface2)', border: '0.5px solid var(--border)', borderRadius: 8, padding: '12px 14px' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: (expedientePrincipal || incidentes.length > 0) ? 10 : 0 }}>
                <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--text4)', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                  Expedientes vinculados
                </span>
                <button className="btn btn-ghost btn-sm" style={{ fontSize: 11, border: '1px solid var(--border2)', color: 'var(--text2)' }} onClick={() => setModalNuevoIncidente(true)}>
                  + Agregar incidente
                </button>
              </div>
              {!expedientePrincipal && incidentes.length === 0 && (
                <div style={{ fontSize: 12, color: 'var(--text4)' }}>Este expediente no tiene vinculados.</div>
              )}
              {expedientePrincipal && (
                <div style={{ marginBottom: 6, display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ fontSize: 10, background: '#dbeafe', color: '#1d4ed8', borderRadius: 4, padding: '1px 7px', fontWeight: 600 }}>PRINCIPAL</span>
                  <span
                    onClick={() => onNavigateExpediente?.(expedientePrincipal.id)}
                    style={{ fontSize: 12, color: 'var(--blue)', cursor: 'pointer', fontWeight: 500 }}
                  >
                    {expedientePrincipal.numero ? `${expedientePrincipal.numero} — ` : ''}{expedientePrincipal.caratula}
                  </span>
                </div>
              )}
              {incidentes.map(inc => (
                <div key={inc.id} style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                  <span style={{ fontSize: 10, background: '#f3e8ff', color: '#7c3aed', borderRadius: 4, padding: '1px 7px', fontWeight: 600 }}>INCIDENTE</span>
                  <span
                    onClick={() => onNavigateExpediente?.(inc.id)}
                    style={{ fontSize: 12, color: 'var(--blue)', cursor: 'pointer', fontWeight: 500 }}
                  >
                    {inc.numero ? `${inc.numero} — ` : ''}{inc.caratula}
                  </span>
                </div>
              ))}
            </div>

            {(() => {
              const fichaItems = [
                { label: 'Juzgado', value: expediente.juzgado },
                { label: 'Juez', value: expediente.juez },
                { label: 'Actuario', value: expediente.actuario },
                { label: 'Secretaría', value: expediente.secretaria },
                { label: 'Jurisdicción', value: expediente.jurisdiccion },
                { label: 'Tipo de juicio', value: expediente.tipo_juicio },
                { label: 'Acción', value: expediente.tipo_accion },
                { label: 'Tipo de trámite', value: expediente.tipo_tramite },
                { label: 'Fecha de inicio', value: formatDate(expediente.fecha_inicio) },
                { label: 'Fecha de intervención', value: formatDate(expediente.fecha_intervencion) },
                { label: 'Último movimiento', value: formatDate(expediente.fecha_ultimo_movimiento) },
                { label: 'Parte contraria', value: expediente.parte_contraria },
                { label: 'Letrado contrario', value: expediente.letrado_contrario },
                { label: 'Monto reclamado', value: expediente.monto_reclamado ? '$' + Number(expediente.monto_reclamado).toLocaleString('es-AR') : null },
              ].filter(i => i.value);
              return (
                <>
                  {fichaItems.length > 0 && (
                    <div className="info-grid" style={{ marginBottom: 10 }}>
                      {fichaItems.map(item => (
                        <div className="info-item" key={item.label}>
                          <label>{item.label}</label>
                          <span>{item.value}</span>
                        </div>
                      ))}
                    </div>
                  )}
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
                    <button className="btn btn-primary btn-sm" onClick={openEditarExpediente}>
                      {fichaItems.length > 0 ? 'Modificar Ficha' : 'Agregar Ficha'}
                    </button>
                  </div>
                </>
              );
            })()}
            <div style={{ borderTop: '0.5px solid var(--border)', paddingTop: 14 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 }}>Notas</div>
              <div style={{ background: 'var(--surface2)', border: '0.5px solid var(--border)', borderRadius: 8, padding: '10px 12px', marginBottom: 8 }}>
                <textarea
                  className="form-textarea"
                  value={nuevaNota}
                  onChange={e => setNuevaNota(e.target.value)}
                  placeholder="Escribí una nueva nota..."
                  style={{ minHeight: 60, width: '100%', boxSizing: 'border-box', background: 'transparent', border: 'none', resize: 'vertical', outline: 'none', fontSize: 13, color: 'var(--text2)', lineHeight: 1.6 }}
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 4 }}>
                  <button className="btn btn-primary btn-sm" onClick={addNota} disabled={!nuevaNota.trim()}>
                    + Agregar nota
                  </button>
                </div>
              </div>
              {notas.length > 0 && (
                <div style={{ background: 'var(--surface2)', border: '0.5px solid var(--border)', borderRadius: 8, padding: 8, display: 'flex', flexDirection: 'column', gap: 6 }}>
                  {notas.map(n => (
                    <div key={n.id} style={{ padding: '10px 12px', background: 'var(--surface)', border: '0.5px solid var(--border)', borderRadius: 6 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 4 }}>
                        <span style={{ fontSize: 11, color: 'var(--text4)', fontFamily: 'DM Mono' }}>
                          {new Date(n.created_at).toLocaleString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                        </span>
                        {esAdmin && <button className="btn btn-danger btn-xs" onClick={() => deleteNota(n.id)}>🗑</button>}
                      </div>
                      <div style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{n.contenido}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {/* TAB TAREAS */}
        {tabActiva === 'tareas' && (
          <div>
            {/* Toolbar */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, gap: 12 }}>
              <div style={{ display: 'flex', gap: 16 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: 'var(--text4)', cursor: 'pointer', userSelect: 'none' }}>
                  <input type="checkbox" checked={mostrarCompletadas} onChange={e => setMostrarCompletadas(e.target.checked)} />
                  Ver completadas ({tareasCompletadas.length})
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: 'var(--text4)', cursor: 'pointer', userSelect: 'none' }}>
                  <input type="checkbox" checked={mostrarDescartadas} onChange={e => setMostrarDescartadas(e.target.checked)} />
                  Ver descartadas ({tareasDescartadas.length})
                </label>
              </div>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                {nuevoGrupoInlineOpen ? (
                  <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                    <input
                      className="form-input"
                      style={{ height: 28, padding: '0 8px', fontSize: 12, width: 140 }}
                      autoFocus
                      value={nuevoGrupoNombre}
                      onChange={e => setNuevoGrupoNombre(e.target.value)}
                      placeholder="Nombre del grupo"
                      onKeyDown={e => { if (e.key === 'Enter') crearGrupoInline(); if (e.key === 'Escape') { setNuevoGrupoInlineOpen(false); setNuevoGrupoNombre(''); } }}
                    />
                    <button className="btn btn-primary btn-sm" onClick={crearGrupoInline} disabled={!nuevoGrupoNombre.trim()}>Crear</button>
                    <button className="btn btn-ghost btn-sm" onClick={() => { setNuevoGrupoInlineOpen(false); setNuevoGrupoNombre(''); }}>✕</button>
                  </div>
                ) : (
                  <button className="btn btn-ghost btn-sm" onClick={() => setNuevoGrupoInlineOpen(true)}>📁 Nuevo grupo</button>
                )}
                <button className="btn btn-primary btn-sm" onClick={() => openNuevaTarea()}>+ Nueva tarea</button>
              </div>
            </div>

            {tareasPendientes.length === 0 && !mostrarCompletadas && !mostrarDescartadas ? (
              <div className="empty-state" style={{ padding: 32 }}>
                <div className="empty-state-icon">📋</div>
                <div className="empty-state-title">Sin tareas pendientes</div>
              </div>
            ) : (
              <>
                <DndContext
                  sensors={sensors}
                  collisionDetection={colisionDnd}
                  onDragStart={handleDndStart}
                  onDragOver={handleDndOver}
                  onDragEnd={handleDndEnd}
                  onDragCancel={() => { contenedoresRef.current = null; setContenedoresDrag(null); setActiveDragId(null); }}
                >
                  <SortableContext items={vista.ordenTop} strategy={verticalListSortingStrategy}>
                    {vista.ordenTop.map(token => {
                      if (token.startsWith('t:')) {
                        const t = tareas.find(x => x.id === token.slice(2));
                        if (!t) return null;
                        return (
                          <SortableTarea key={token} id={token} cardProps={{
                            tarea: t, onToggle: toggleTarea, onFijar: toggleFijada, onEdit: openEditTarea,
                            onDelete: deleteTarea, onDescartar: descartarTarea, onVerDetalle: setTareaDetalleId,
                            onAsignar: () => openModalAsignar([t], t.titulo),
                            prioridadColor, formatDate, today, prueba: tareasPruebaRef[t.id] || null,
                          }} />
                        );
                      }
                      const nombre = token.slice(2);
                      const memberTokens = vista.grupos[nombre] || [];
                      const tareasGrupo = memberTokens.map(mt => tareas.find(x => x.id === mt.slice(2))).filter(Boolean);
                      return (
                        <SortableGrupo
                          key={token} id={token} nombre={nombre}
                          memberTokens={memberTokens} tareasGrupo={tareasGrupo}
                          colapsado={gruposColapsados[nombre]}
                          onToggleColapso={() => setGruposColapsados(prev => ({ ...prev, [nombre]: !prev[nombre] }))}
                          renombrando={renombrandoGrupo === nombre}
                          renombreValor={renombreValor} setRenombreValor={setRenombreValor}
                          onRenombrarStart={() => { setRenombrandoGrupo(nombre); setRenombreValor(nombre); }}
                          onRenombrarConfirm={() => renombrarGrupo(nombre, renombreValor)}
                          onRenombrarCancel={() => { setRenombrandoGrupo(null); setRenombreValor(''); }}
                          onAsignarGrupo={() => openModalAsignar(tareasGrupo, nombre)}
                          onNuevaTarea={() => openNuevaTarea(nombre)}
                          onEliminar={() => eliminarGrupo(nombre)}
                          esAdmin={esAdmin}
                          cardPropsFor={(t) => ({
                            tarea: t, onToggle: toggleTarea, onFijar: toggleFijada, onEdit: openEditTarea,
                            onDelete: deleteTarea, onDescartar: descartarTarea, onVerDetalle: setTareaDetalleId,
                            onAsignar: () => openModalAsignar([t], t.titulo),
                            prioridadColor, formatDate, today, prueba: tareasPruebaRef[t.id] || null,
                          })}
                        />
                      );
                    })}
                  </SortableContext>
                  <DragOverlay>
                    {activeDragId && activeDragId.startsWith('t:') && (() => {
                      const t = tareas.find(x => x.id === activeDragId.slice(2));
                      return t ? <TareaCard tarea={t} prioridadColor={prioridadColor} formatDate={formatDate} today={today} prueba={tareasPruebaRef[t.id] || null} overlay /> : null;
                    })()}
                    {activeDragId && activeDragId.startsWith('g:') && (
                      <div style={{ background: '#e2e6ea', border: '1px solid var(--blue)', borderRadius: 10, padding: '8px 12px', display: 'flex', alignItems: 'center', gap: 8, boxShadow: '0 8px 24px rgba(0,0,0,0.18)' }}>
                        <span style={{ fontSize: 14, color: 'var(--text4)' }}>⠿</span>
                        <span style={{ fontSize: 13 }}>📁</span>
                        <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--text2)', textTransform: 'uppercase', letterSpacing: 0.5 }}>{activeDragId.slice(2)}</span>
                      </div>
                    )}
                  </DragOverlay>
                </DndContext>

                {mostrarCompletadas && tareasCompletadas.length > 0 && (
                  <>
                    <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text4)', textTransform: 'uppercase', letterSpacing: 0.5, margin: '16px 0 8px', paddingTop: 12, borderTop: '0.5px solid var(--border)' }}>
                      Completadas ({tareasCompletadas.length})
                    </div>
                    {tareasCompletadas.map(t => (
                      <TareaCard key={t.id} tarea={t} onToggle={toggleTarea} onFijar={toggleFijada} onEdit={openEditTarea} onDelete={deleteTarea} onDescartar={descartarTarea} onVerDetalle={setTareaDetalleId} prioridadColor={prioridadColor} formatDate={formatDate} today={today} completada prueba={tareasPruebaRef[t.id] || null} />
                    ))}
                  </>
                )}

                {mostrarDescartadas && tareasDescartadas.length > 0 && (
                  <>
                    <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text4)', textTransform: 'uppercase', letterSpacing: 0.5, margin: '16px 0 8px', paddingTop: 12, borderTop: '0.5px solid var(--border)' }}>
                      Descartadas ({tareasDescartadas.length})
                    </div>
                    {tareasDescartadas.map(t => (
                      <TareaCard key={t.id} tarea={t} onToggle={toggleTarea} onFijar={toggleFijada} onEdit={openEditTarea} onDelete={deleteTarea} onReactivar={reactivarTarea} onVerDetalle={setTareaDetalleId} prioridadColor={prioridadColor} formatDate={formatDate} today={today} descartada prueba={tareasPruebaRef[t.id] || null} />
                    ))}
                  </>
                )}
              </>
            )}
          </div>
        )}
        {tabActiva === 'audiencias' && (() => {
          const todayStr = new Date().toISOString().split('T')[0];
          const proximaAudiencia = audiencias
            .filter(a => a.estado !== 'cancelado' && (a.fecha || '') >= todayStr)
            .sort((a, b) => (a.fecha || '') < (b.fecha || '') ? -1 : (a.fecha || '') > (b.fecha || '') ? 1 : (a.hora || '') < (b.hora || '') ? -1 : 1)[0] || null;
          return (
            <div>
              {/* Toolbar */}
              <div style={{ marginBottom: 12 }}>
                {/* Fila 1: info + toggles */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 8 }}>
                  {proximaAudiencia ? (() => {
                    const dias = Math.round((new Date(proximaAudiencia.fecha + 'T12:00:00') - new Date(todayStr + 'T12:00:00')) / 86400000);
                    return (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }} onClick={() => setAudienciaDetalleId(proximaAudiencia.id)}>
                        <span style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.4, color: 'var(--text4)' }}>Próxima</span>
                        <span style={{ fontSize: 13, fontWeight: 600, color: dias <= 7 ? '#dc2626' : dias <= 14 ? '#ca8a04' : '#16a34a' }}>
                          {new Date(proximaAudiencia.fecha + 'T12:00:00').toLocaleDateString('es-AR', { day: '2-digit', month: 'short', year: 'numeric' })}
                        </span>
                      </div>
                    );
                  })() : (
                    <span style={{ fontSize: 12, color: 'var(--text4)' }}>Sin audiencias próximas</span>
                  )}
                  {audiencias.some(a => a.estado === 'realizado') && (
                    <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: 'var(--text4)', cursor: 'pointer', userSelect: 'none' }}>
                      <input type="checkbox" checked={mostrarRealizadas} onChange={e => setMostrarRealizadas(e.target.checked)} />
                      Ver realizadas ({audiencias.filter(a => a.estado === 'realizado').length})
                    </label>
                  )}
                  {audiencias.some(a => a.estado === 'cancelado') && (
                    <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: 'var(--text4)', cursor: 'pointer', userSelect: 'none' }}>
                      <input type="checkbox" checked={mostrarCanceladas} onChange={e => setMostrarCanceladas(e.target.checked)} />
                      Ver canceladas ({audiencias.filter(a => a.estado === 'cancelado').length})
                    </label>
                  )}
                </div>
                {/* Fila 2: botones */}
                <div style={{ display: 'flex', gap: 6, alignItems: 'center', justifyContent: 'flex-end' }}>
                  {nuevoGrupoAudienciaOpen ? (
                    <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                      <input
                        className="form-input"
                        style={{ height: 28, padding: '0 8px', fontSize: 12, width: 130 }}
                        autoFocus
                        value={nuevoGrupoAudienciaNombre}
                        onChange={e => setNuevoGrupoAudienciaNombre(e.target.value)}
                        placeholder="Nombre del grupo"
                        onKeyDown={e => {
                          if (e.key === 'Enter') crearGrupoAudienciaInline();
                          if (e.key === 'Escape') { setNuevoGrupoAudienciaOpen(false); setNuevoGrupoAudienciaNombre(''); }
                        }}
                      />
                      <button className="btn btn-primary btn-sm" disabled={!nuevoGrupoAudienciaNombre.trim()} onClick={crearGrupoAudienciaInline}>Crear</button>
                      <button className="btn btn-ghost btn-sm" onClick={() => { setNuevoGrupoAudienciaOpen(false); setNuevoGrupoAudienciaNombre(''); }}>✕</button>
                    </div>
                  ) : (
                    <button className="btn btn-ghost btn-sm" onClick={() => setNuevoGrupoAudienciaOpen(true)}>📁 Nuevo grupo</button>
                  )}
                  <button className="btn btn-primary btn-sm" onClick={() => { setFormAudiencia({ titulo: '', tipo: 'Audiencia', fecha: '', hora: '00:00', notas: '', estado: 'pendiente', grupo: '' }); setEditingAudienciaId(null); setModalAudienciaOpen(true); }}>+ Nueva audiencia / turno</button>
                </div>
              </div>

              {audiencias.length === 0 ? (
                <div className="empty-state" style={{ padding: 32 }}>
                  <div className="empty-state-title">Sin audiencias ni turnos</div>
                  <div>Creá el primero con el botón de arriba</div>
                </div>
              ) : (
                <>

                  <DndContext
                    sensors={sensors}
                    collisionDetection={colisionDnd}
                    onDragStart={handleDndAudStart}
                    onDragOver={handleDndAudOver}
                    onDragEnd={handleDndAudEnd}
                    onDragCancel={() => { contenedoresAudRef.current = null; setContenedoresAudDrag(null); setActiveDragAudId(null); }}
                  >
                    <SortableContext items={vistaAud.ordenTop} strategy={verticalListSortingStrategy}>
                      {vistaAud.ordenTop.map(token => {
                        if (token.startsWith('a:')) {
                          const a = audiencias.find(x => x.id === token.slice(2));
                          if (!a) return null;
                          return (
                            <SortableAudiencia key={token} id={token} cardProps={{
                              a,
                              onClickCard: () => setAudienciaDetalleId(a.id),
                              onClickAsignar: () => openModalAsignar([{ id: a.id, titulo: a.titulo }], a.titulo, 'audiencia'),
                              onCambiarEstado: (estado) => setEstadoAudiencia(a.id, estado),
                              onDelete: () => deleteAudiencia(a.id),
                              esAdmin,
                              prueba: audienciasPruebaRef[a.id] || null,
                            }} />
                          );
                        }
                        const nombre = token.slice(2);
                        const memberTokens = vistaAud.grupos[nombre] || [];
                        const audsGrupo = memberTokens.map(mt => audiencias.find(x => x.id === mt.slice(2))).filter(Boolean);
                        return (
                          <SortableGrupoAudiencia
                            key={token} id={token} nombre={nombre}
                            memberTokens={memberTokens} audsGrupo={audsGrupo}
                            colapsado={gruposAudienciasColapsados[nombre]}
                            onToggleColapso={() => setGruposAudienciasColapsados(prev => ({ ...prev, [nombre]: !prev[nombre] }))}
                            renombrando={renombrandoGrupoAudiencia === nombre}
                            renombreValor={renombreAudienciaValor} setRenombreValor={setRenombreAudienciaValor}
                            onRenombrarStart={() => { setRenombrandoGrupoAudiencia(nombre); setRenombreAudienciaValor(nombre); }}
                            onRenombrarConfirm={() => renombrarGrupoAudiencia(nombre, renombreAudienciaValor)}
                            onRenombrarCancel={() => { setRenombrandoGrupoAudiencia(null); setRenombreAudienciaValor(''); }}
                            onAsignarGrupo={() => openModalAsignar(audsGrupo.map(a => ({ id: a.id, titulo: a.titulo })), nombre, 'audiencia')}
                            onNuevaAudiencia={() => { setFormAudiencia({ titulo: '', tipo: 'Audiencia', fecha: '', hora: '', notas: '', estado: 'pendiente', grupo: nombre }); setEditingAudienciaId(null); setModalAudienciaOpen(true); }}
                            onEliminar={() => eliminarGrupoAudiencia(nombre)}
                            esAdmin={esAdmin}
                            cardPropsFor={(a) => ({
                              a,
                              onClickCard: () => setAudienciaDetalleId(a.id),
                              onClickAsignar: () => openModalAsignar([{ id: a.id, titulo: a.titulo }], a.titulo, 'audiencia'),
                              onCambiarEstado: (estado) => setEstadoAudiencia(a.id, estado),
                              onDelete: () => deleteAudiencia(a.id),
                              esAdmin,
                              prueba: audienciasPruebaRef[a.id] || null,
                            })}
                          />
                        );
                      })}
                    </SortableContext>
                    <DragOverlay>
                      {activeDragAudId && activeDragAudId.startsWith('a:') && (() => {
                        const a = audiencias.find(x => x.id === activeDragAudId.slice(2));
                        return a ? <AudienciaCard a={a} prueba={audienciasPruebaRef[a.id] || null} overlay /> : null;
                      })()}
                      {activeDragAudId && activeDragAudId.startsWith('g:') && (
                        <div style={{ background: '#e2e6ea', border: '1px solid var(--blue)', borderRadius: 10, padding: '8px 12px', display: 'flex', alignItems: 'center', gap: 8, boxShadow: '0 8px 24px rgba(0,0,0,0.18)' }}>
                          <span style={{ fontSize: 14, color: 'var(--text4)' }}>⠿</span>
                          <span style={{ fontSize: 13 }}>📁</span>
                          <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--text2)', textTransform: 'uppercase', letterSpacing: 0.5 }}>{activeDragAudId.slice(2)}</span>
                        </div>
                      )}
                    </DragOverlay>
                  </DndContext>

                  {/* Realizadas */}
                  {mostrarRealizadas && audiencias.some(a => a.estado === 'realizado') && (
                    <>
                      <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text4)', textTransform: 'uppercase', letterSpacing: 0.5, margin: '16px 0 8px', paddingTop: 12, borderTop: '0.5px solid var(--border)' }}>
                        Realizadas ({audiencias.filter(a => a.estado === 'realizado').length})
                      </div>
                      {audiencias.filter(a => a.estado === 'realizado').map(a => (
                        <AudienciaCard
                          key={a.id} a={a}
                          onClickCard={() => setAudienciaDetalleId(a.id)}
                          onClickAsignar={() => openModalAsignar([{ id: a.id, titulo: a.titulo }], a.titulo, 'audiencia')}
                          onCambiarEstado={(estado) => setEstadoAudiencia(a.id, estado)}
                          onDelete={() => deleteAudiencia(a.id)}
                          esAdmin={esAdmin}
                          prueba={audienciasPruebaRef[a.id] || null}
                        />
                      ))}
                    </>
                  )}

                  {/* Canceladas */}
                  {mostrarCanceladas && audiencias.some(a => a.estado === 'cancelado') && (
                    <>
                      <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text4)', textTransform: 'uppercase', letterSpacing: 0.5, margin: '16px 0 8px', paddingTop: 12, borderTop: '0.5px solid var(--border)' }}>
                        Canceladas ({audiencias.filter(a => a.estado === 'cancelado').length})
                      </div>
                      {audiencias.filter(a => a.estado === 'cancelado').map(a => (
                        <AudienciaCard
                          key={a.id} a={a}
                          onClickCard={() => setAudienciaDetalleId(a.id)}
                          onClickAsignar={() => openModalAsignar([{ id: a.id, titulo: a.titulo }], a.titulo, 'audiencia')}
                          onCambiarEstado={(estado) => setEstadoAudiencia(a.id, estado)}
                          onDelete={() => deleteAudiencia(a.id)}
                          esAdmin={esAdmin}
                          prueba={audienciasPruebaRef[a.id] || null}
                        />
                      ))}
                    </>
                  )}
                </>
              )}
            </div>
          );
        })()}

        {/* TAB MOVIMIENTOS */}
        {tabActiva === 'movimientos' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
              <button className="btn btn-primary btn-sm" onClick={() => { setFormMov({ descripcion: '', fecha: new Date().toISOString().split('T')[0] }); setModalMovOpen(true); }}>
                + Nuevo movimiento
              </button>
            </div>
            {movimientos.length === 0 ? (
              <div className="empty-state" style={{ padding: 32 }}>
                <div className="empty-state-icon">📝</div>
                <div className="empty-state-title">Sin movimientos registrados</div>
              </div>
            ) : movimientos.map(m => (
              <div key={m.id} className="mov-item">
                <div className="mov-fecha">{formatDate(m.fecha)}</div>
                <div className="mov-desc">{m.descripcion}</div>
                {esAdmin && <button className="btn btn-danger btn-xs" onClick={() => deleteMovimiento(m.id)}>🗑</button>}
              </div>
            ))}
          </div>
        )}

        {/* TAB PRUEBA */}
        {tabActiva === 'prueba' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
              <span style={{ fontSize: 13, color: 'var(--text4)' }}>{pruebas.length} elemento{pruebas.length !== 1 ? 's' : ''}</span>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => {
                  setEditingPruebaId(null);
                  setFormPrueba({ tipo: 'testimonial', estado: 'no_instada', descripcion: '', nombre: '', parte: 'nuestra' });
                  setModalPruebaOpen(true);
                }}
              >
                + Nueva prueba
              </button>
            </div>
            {!(expediente?.prueba_habilitada ?? true) ? (
              <div style={{ padding: '32px 16px', textAlign: 'center', background: 'var(--surface2)', borderRadius: 10, border: '0.5px solid var(--border)' }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)', marginBottom: 6 }}>Prueba deshabilitada</div>
                <div style={{ fontSize: 12, color: 'var(--text4)' }}>Este expediente no tiene etapa de apertura a prueba.</div>
              </div>
            ) : pruebas.length === 0 ? (
              <div style={{ padding: '40px 16px', textAlign: 'center', background: 'var(--surface2)', borderRadius: 10, border: '1px dashed var(--border)' }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)', marginBottom: 6 }}>Sin pruebas registradas</div>
                <div style={{ fontSize: 12, color: 'var(--text4)', marginBottom: 16 }}>Agregá la primera prueba del expediente.</div>
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => {
                    setEditingPruebaId(null);
                    setFormPrueba({ tipo: 'testimonial', estado: 'no_instada', descripcion: '', nombre: '', parte: 'nuestra' });
                    setModalPruebaOpen(true);
                  }}
                >
                  + Nueva prueba
                </button>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {pruebas.map(p => {
                  const cfg = TIPO_PRUEBA[p.tipo] || TIPO_PRUEBA.otro;
                  const est = ESTADO_PRUEBA[p.estado] || ESTADO_PRUEBA.no_instada;
                  const titulo = p.nombre || p.descripcion || cfg.label;
                  return (
                    <div
                      key={p.id}
                      onClick={() => { setPruebaDetalleId(p.id); fetchPruebaEventos(p.id); }}
                      style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', background: 'var(--surface)', border: '0.5px solid var(--border)', borderLeft: `3px solid ${cfg.color}`, borderRadius: 8, cursor: 'pointer', transition: 'opacity 0.15s' }}
                      onMouseEnter={e => e.currentTarget.style.opacity = '0.75'}
                      onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                    >
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--text)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{titulo}</div>
                        <div style={{ fontSize: 11, color: cfg.color, marginTop: 2, fontWeight: 600 }}>{cfg.label}</div>
                      </div>
                      <span style={{ fontSize: 10, padding: '2px 8px', borderRadius: 10, background: p.parte === 'contraparte' ? '#fef2f2' : '#eff6ff', color: p.parte === 'contraparte' ? '#ef4444' : '#3b82f6', border: `0.5px solid ${p.parte === 'contraparte' ? '#fecaca' : '#bfdbfe'}`, fontWeight: 600, whiteSpace: 'nowrap', flexShrink: 0 }}>{p.parte === 'contraparte' ? 'Contraparte' : 'Nuestra'}</span>
                      <span style={{ fontSize: 10, padding: '2px 8px', borderRadius: 10, background: est.bg, color: est.color, border: `0.5px solid ${est.border}`, fontWeight: 600, whiteSpace: 'nowrap', flexShrink: 0 }}>{est.label}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* TAB NOTAS */}
        {/* TAB ESTADO PROCESAL */}
        {tabActiva === 'estado_procesal' && (
          <div>
            {/* Header etapa actual */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
              <div>
                <div style={{ fontSize: 11, color: 'var(--text4)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 2 }}>Etapa actual</div>
                <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--text)' }}>
                  {etapaActual ? etapaActual.nombre : <span style={{ color: 'var(--text4)', fontWeight: 400, fontSize: 13 }}>Sin etapa asignada</span>}
                </div>
                {etapaActual && <div style={{ fontSize: 11, color: 'var(--text4)', marginTop: 2 }}>Desde {new Date(etapaActual.fecha_inicio).toLocaleDateString('es-AR')}</div>}
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                {etapaActual && (
                  <button className="btn btn-ghost btn-sm" onClick={() => {
                    setNombreEtapaEdit(etapaActual.nombre);
                    setModalEditarEtapa(true);
                  }}>
                    Editar etapa
                  </button>
                )}
                <button className="btn btn-primary btn-sm" onClick={async () => {
                  try {
                    if (expediente?.tipo_juicio_id) await fetchEtapasPlantilla(expediente.tipo_juicio_id);
                    else setEtapasPlantilla([]);
                  } catch(e) { console.error(e); setEtapasPlantilla([]); }
                  setNuevaEtapaNombre('');
                  setEtapaPersonalizada(false);
                  setModalCambiarEtapa(true);
                }}>
                  {etapaActual ? 'Avanzar a la siguiente etapa' : 'Iniciar etapa'}
                </button>
              </div>
            </div>

            {/* Requisitos etapa actual */}
            {etapaActual && (
              <div style={{ marginBottom: 20 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                  <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--text)', textTransform: 'uppercase', letterSpacing: 0.5 }}>Requisitos</span>
                  <button className="btn btn-ghost btn-xs" onClick={() => { setNuevoReqTexto(''); setModalNuevoReq(true); }}>+ Agregar</button>
                </div>
                {requisitosEtapa.length === 0 && (
                  <div style={{ padding: '20px 0', textAlign: 'center', color: 'var(--text4)', fontSize: 13 }}>Sin requisitos en esta etapa</div>
                )}
                {requisitosEtapa.map(r => (
                  <div key={r.id} style={{ background: 'var(--surface2)', border: '0.5px solid var(--border)', borderRadius: 8, padding: '10px 12px', marginBottom: 8 }}>
                    {editReqId === r.id ? (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <input className="form-input" style={{ fontSize: 13 }} value={editReqData.texto} onChange={e => setEditReqData(d => ({ ...d, texto: e.target.value }))} />
                        <div style={{ display: 'flex', gap: 8 }}>
                          <select className="form-select" style={{ flex: 1, fontSize: 12 }} value={editReqData.estado} onChange={e => setEditReqData(d => ({ ...d, estado: e.target.value }))}>
                            <option value="pendiente">Pendiente</option>
                            <option value="en curso">En curso</option>
                            <option value="completada">Completada</option>
                          </select>
                          <input className="form-input" type="date" style={{ flex: 1, fontSize: 12 }} value={editReqData.fecha ? editReqData.fecha.split('T')[0] : ''} onChange={e => setEditReqData(d => ({ ...d, fecha: e.target.value }))} />
                        </div>
                        <textarea className="form-textarea" style={{ fontSize: 12, minHeight: 50 }} placeholder="Notas..." value={editReqData.notas || ''} onChange={e => setEditReqData(d => ({ ...d, notas: e.target.value }))} />
                        <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
                          <button className="btn btn-ghost btn-xs" onClick={() => setEditReqId(null)}>Cancelar</button>
                          <button className="btn btn-primary btn-xs" onClick={async () => { await updateRequisito(r.id, { texto: editReqData.texto, estado: editReqData.estado, fecha: editReqData.fecha || null, notas: editReqData.notas }); setEditReqId(null); }}>Guardar</button>
                        </div>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                        {/* CHECKBOX */}
                        <input
                          type="checkbox"
                          checked={r.estado === 'completada'}
                          onChange={() => toggleRequisito(r)}
                          disabled={togglingReq.has(r.id)}
                          style={{ marginTop: 3, width: 15, height: 15, flexShrink: 0, cursor: 'pointer', accentColor: 'var(--blue)' }}
                        />
                        {/* CONTENIDO */}
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8 }}>
                            <div style={{ flex: 1, cursor: 'pointer' }} onClick={() => openRequisitoDetalle(r)}>
                              <div style={{ fontSize: 13, fontWeight: 500, color: r.estado === 'completada' ? 'var(--text4)' : 'var(--text)', textDecoration: r.estado === 'completada' ? 'line-through' : 'none', marginBottom: 4 }}>
                                {r.texto}
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                                {r.estado === 'en curso' && (
                                  <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 20, fontWeight: 500, background: '#dbeafe', color: '#2563eb', border: '0.5px solid currentColor' }}>
                                    En curso
                                  </span>
                                )}
                                {r.fecha && (
                                  <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 20, background: '#eff6ff', color: '#3b82f6', border: '0.5px solid #bfdbfe', fontWeight: 500 }}>
                                    Agendado para el día {new Date(r.fecha.split('T')[0] + 'T12:00:00').toLocaleDateString('es-AR')}
                                  </span>
                                )}
                                {r.fecha_vencimiento && r.estado !== 'completada' && (() => {
                                  const vencido = r.fecha_vencimiento < new Date().toISOString().split('T')[0];
                                  return (
                                    <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 20, background: vencido ? '#fee2e2' : '#fefce8', color: vencido ? '#dc2626' : '#ca8a04', border: `0.5px solid ${vencido ? '#fecaca' : '#fde68a'}`, fontWeight: 500 }}>
                                      {vencido ? '⚠ Vence ' : 'Vence '}{new Date(r.fecha_vencimiento.split('T')[0] + 'T12:00:00').toLocaleDateString('es-AR')}
                                    </span>
                                  );
                                })()}
                                {r.producida_en && <span style={{ fontSize: 11, color: '#16a34a', fontFamily: 'DM Mono' }}>✓ {new Date(r.producida_en).toLocaleDateString('es-AR')}</span>}
                              </div>
                              {r.notas && <div style={{ fontSize: 12, color: 'var(--text4)', marginTop: 4, fontStyle: 'italic' }}>{r.notas}</div>}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* Historial */}
            {historialEtapas.length > 0 && (
              <div>
                <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 10, paddingTop: 10, borderTop: '0.5px solid var(--border)' }}>Historial de etapas</div>
                {historialEtapas.map(e => (
                  <div key={e.id} onClick={() => setEtapaHistorialDetalle(e)} style={{ background: 'var(--surface2)', border: '0.5px solid var(--border)', borderRadius: 8, padding: '10px 12px', marginBottom: 8, opacity: 0.85, cursor: 'pointer', transition: 'opacity 0.15s' }}
                    onMouseEnter={ev => ev.currentTarget.style.opacity = 1} onMouseLeave={ev => ev.currentTarget.style.opacity = 0.85}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)' }}>{e.nombre}</span>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: 11, color: 'var(--text4)', fontFamily: 'DM Mono' }}>{new Date(e.fecha_inicio).toLocaleDateString('es-AR')}</span>
                        {e.expediente_requisitos?.length > 0 && (
                          <span style={{ fontSize: 11, color: 'var(--text4)' }}>{e.expediente_requisitos.filter(r => r.estado === 'completada').length}/{e.expediente_requisitos.length} req.</span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Movimientos */}
            <div style={{ marginTop: 20, paddingTop: 16, borderTop: '0.5px solid var(--border)' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--text)', textTransform: 'uppercase', letterSpacing: 0.5 }}>Movimientos ({movimientos.length})</span>
                <button className="btn btn-primary btn-sm" onClick={() => { setFormMov({ descripcion: '', fecha: new Date().toISOString().split('T')[0] }); setModalMovOpen(true); }}>
                  + Nuevo movimiento
                </button>
              </div>
              {movimientos.length === 0 ? (
                <div className="empty-state" style={{ padding: 32 }}>
                  <div className="empty-state-icon">📝</div>
                  <div className="empty-state-title">Sin movimientos registrados</div>
                </div>
              ) : movimientos.map(m => (
                <div key={m.id} className="mov-item">
                  <div className="mov-fecha">{formatDate(m.fecha)}</div>
                  <div className="mov-desc">{m.descripcion}</div>
                  {esAdmin && <button className="btn btn-danger btn-xs" onClick={() => deleteMovimiento(m.id)}>🗑</button>}
                </div>
              ))}
            </div>
          </div>
        )}

      </div>

      {/* MODAL TAREA */}

      {modalTareaOpen && (
        <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setModalTareaOpen(false)}>
          <div className="modal" style={{ width: 500 }}
            onKeyDown={e => { if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA' && e.target.tagName !== 'SELECT') saveTarea(); }}
          >
            <div className="modal-header">
              <div className="modal-title">{editingTareaId ? 'Editar tarea' : 'Nueva tarea'}</div>
              <button className="modal-close" onClick={() => setModalTareaOpen(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-grid">
                <div className="form-group form-full">
                  <label className="form-label">Título *</label>
                  <input className="form-input" value={formTarea.titulo} onChange={e => setFormTarea(f => ({ ...f, titulo: e.target.value }))} placeholder="Descripción de la tarea" autoFocus />
                </div>
                <div className="form-group form-full">
                  <label className="form-label">Descripción</label>
                  <textarea className="form-textarea" value={formTarea.descripcion} onChange={e => setFormTarea(f => ({ ...f, descripcion: e.target.value }))} placeholder="Detalles adicionales..." />
                </div>
                <div className="form-group">
                  <label className="form-label">Fecha de Realización</label>
                  <input className="form-input" type="date" value={formTarea.fecha} onChange={e => setFormTarea(f => ({ ...f, fecha: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label className="form-label">Vencimiento</label>
                  <input className="form-input" type="date" value={formTarea.fecha_vencimiento} onChange={e => setFormTarea(f => ({ ...f, fecha_vencimiento: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label className="form-label">Prioridad</label>
                  <select className="form-select" value={formTarea.prioridad} onChange={e => setFormTarea(f => ({ ...f, prioridad: e.target.value }))}>
                    <option value="urgente">Urgente</option>
                    <option value="muy importante">Muy importante</option>
                    <option value="normal">Normal</option>
                    <option value="baja">Baja</option>
                  </select>
                </div>
                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: 8, paddingTop: 22 }}>
                  <input type="checkbox" id="fijada" checked={formTarea.fijada} onChange={e => setFormTarea(f => ({ ...f, fijada: e.target.checked }))} />
                  <label htmlFor="fijada" style={{ fontSize: 13, color: 'var(--text2)', cursor: 'pointer' }}>Fijar arriba</label>
                </div>
                <div className="form-group form-full">
                  <label className="form-label">Grupo</label>
                  {!formTareaGrupoNuevo ? (
                    <select
                      className="form-select"
                      value={formTarea.grupo}
                      onChange={e => {
                        if (e.target.value === '__nuevo__') {
                          setFormTareaGrupoNuevo(true);
                          setFormTareaGrupoNuevoValor('');
                        } else {
                          setFormTarea(f => ({ ...f, grupo: e.target.value }));
                        }
                      }}
                    >
                      <option value="">Sin grupo</option>
                      {grupos.map(g => <option key={g} value={g}>{g}</option>)}
                      <option value="__nuevo__">Nuevo grupo...</option>
                    </select>
                  ) : (
                    <div style={{ display: 'flex', gap: 6 }}>
                      <input
                        className="form-input"
                        autoFocus
                        value={formTareaGrupoNuevoValor}
                        onChange={e => setFormTareaGrupoNuevoValor(e.target.value)}
                        placeholder="Nombre del nuevo grupo"
                      />
                      <button className="btn btn-ghost btn-sm" onClick={() => { setFormTareaGrupoNuevo(false); setFormTareaGrupoNuevoValor(''); }}>✕</button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* NOTAS — solo al editar */}
            {editingTareaId && (
              <div style={{ borderTop: '0.5px solid var(--border)', padding: '14px 20px' }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 10 }}>Notas</div>
                <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                  <textarea
                    className="form-textarea"
                    value={nuevaNotaTarea}
                    onChange={e => setNuevaNotaTarea(e.target.value)}
                    placeholder="Agregar una nota..."
                    style={{ minHeight: 60, flex: 1 }}
                  />
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={addNotaTarea}
                    disabled={!nuevaNotaTarea.trim()}
                    style={{ alignSelf: 'flex-end', flexShrink: 0 }}
                  >
                    Agregar
                  </button>
                </div>
                {notasTarea.length === 0 ? (
                  <div style={{ fontSize: 12, color: 'var(--text4)', textAlign: 'center', padding: '8px 0' }}>Sin notas</div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 180, overflowY: 'auto' }}>
                    {notasTarea.map(n => (
                      <div key={n.id} style={{ background: 'var(--surface2)', border: '0.5px solid var(--border)', borderRadius: 7, padding: '8px 12px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                          <span style={{ fontSize: 10, color: 'var(--text4)', fontFamily: 'DM Mono' }}>
                            {new Date(n.created_at).toLocaleString('es-AR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' })}
                          </span>
                          {esAdmin && <button className="btn btn-danger btn-xs" style={{ padding: '0px 5px' }} onClick={() => deleteNotaTarea(n.id)}>🗑</button>}
                        </div>
                        <div style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{n.contenido}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={() => setModalTareaOpen(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={saveTarea} disabled={guardandoTarea}>{guardandoTarea ? 'Guardando...' : 'Guardar tarea'}</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL MOVIMIENTO */}
      {modalMovOpen && (
        <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setModalMovOpen(false)}>
          <div className="modal" style={{ width: 460 }}>
            <div className="modal-header">
              <div className="modal-title">Nuevo movimiento</div>
              <button className="modal-close" onClick={() => setModalMovOpen(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-grid">
                <div className="form-group form-full">
                  <label className="form-label">Descripción *</label>
                  <textarea className="form-textarea" value={formMov.descripcion} onChange={e => setFormMov(f => ({ ...f, descripcion: e.target.value }))} placeholder="Ej: Se presentó escrito de demanda..." autoFocus style={{ minHeight: 100 }} />
                </div>
                <div className="form-group form-full">
                  <label className="form-label">Fecha</label>
                  <input className="form-input" type="date" value={formMov.fecha} onChange={e => setFormMov(f => ({ ...f, fecha: e.target.value }))} />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={() => setModalMovOpen(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={saveMovimiento}>Registrar movimiento</button>
            </div>
          </div>
        </div>
      )}
      {modalAudienciaOpen && (
        <div className="modal-overlay" onMouseDown={e => { if (e.target === e.currentTarget) { setModalAudienciaOpen(false); setEditingAudienciaId(null); setFormAudienciaGrupoNuevo(false); setFormAudienciaGrupoNuevoValor(''); } }}>
          <div className="modal" style={{ width: 500 }}
            onKeyDown={e => { if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA' && e.target.tagName !== 'SELECT') saveAudiencia(); }}
          >
            <div className="modal-header">
              <div className="modal-title">{editingAudienciaId ? 'Editar evento' : 'Nueva audiencia / turno'}</div>
              <button className="modal-close" onClick={() => { setModalAudienciaOpen(false); setEditingAudienciaId(null); setFormAudienciaGrupoNuevo(false); setFormAudienciaGrupoNuevoValor(''); }}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-grid">
                <div className="form-group form-full">
                  <label className="form-label">Título *</label>
                  <input className="form-input" value={formAudiencia.titulo} onChange={e => setFormAudiencia(f => ({ ...f, titulo: e.target.value }))} placeholder="Ej: Audiencia de conciliación" autoFocus />
                </div>
                <div className="form-group">
                  <label className="form-label">Tipo</label>
                  <select className="form-select" value={formAudiencia.tipo} onChange={e => setFormAudiencia(f => ({ ...f, tipo: e.target.value }))}>
                    <option>Audiencia</option>
                    <option>Consulta / Turno</option>
                    <option>Reunión</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Estado</label>
                  <select className="form-select" value={formAudiencia.estado} onChange={e => setFormAudiencia(f => ({ ...f, estado: e.target.value }))}>
                    <option value="pendiente">Pendiente</option>
                    <option value="realizado">Realizado</option>
                    <option value="cancelado">Cancelado</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Fecha *</label>
                  <input className="form-input" type="date" value={formAudiencia.fecha} onChange={e => setFormAudiencia(f => ({ ...f, fecha: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label className="form-label">Hora</label>
                  <input className="form-input" type="time" value={formAudiencia.hora} onChange={e => setFormAudiencia(f => ({ ...f, hora: e.target.value }))} />
                </div>
                <div className="form-group form-full">
                  <label className="form-label">Grupo</label>
                  {!formAudienciaGrupoNuevo ? (
                    <select
                      className="form-select"
                      value={formAudiencia.grupo}
                      onChange={e => {
                        if (e.target.value === '__nuevo__') {
                          setFormAudienciaGrupoNuevo(true);
                          setFormAudienciaGrupoNuevoValor('');
                        } else {
                          setFormAudiencia(f => ({ ...f, grupo: e.target.value }));
                        }
                      }}
                    >
                      <option value="">Sin grupo</option>
                      {gruposAudienciasOrden.map(g => <option key={g} value={g}>{g}</option>)}
                      <option value="__nuevo__">Nuevo grupo...</option>
                    </select>
                  ) : (
                    <div style={{ display: 'flex', gap: 6 }}>
                      <input
                        className="form-input"
                        autoFocus
                        value={formAudienciaGrupoNuevoValor}
                        onChange={e => setFormAudienciaGrupoNuevoValor(e.target.value)}
                        placeholder="Nombre del nuevo grupo"
                        onKeyDown={e => { if (e.key === 'Enter') { e.stopPropagation(); saveAudiencia(); } }}
                      />
                      <button className="btn btn-ghost btn-sm" onClick={() => { setFormAudienciaGrupoNuevo(false); setFormAudienciaGrupoNuevoValor(''); }}>✕</button>
                    </div>
                  )}
                </div>
                <div className="form-group form-full">
                  <label className="form-label">Notas</label>
                  <textarea className="form-textarea" value={formAudiencia.notas} onChange={e => setFormAudiencia(f => ({ ...f, notas: e.target.value }))} placeholder="Detalles adicionales..." />
                </div>
              </div>
            </div>
            <div className="modal-footer" style={{ flexDirection: 'column', alignItems: 'stretch', gap: 10 }}>
              {audienciaError && (
                <div style={{ background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#b91c1c', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8 }}>
                  ⚠️ {audienciaError}
                </div>
              )}
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                <button className="btn btn-ghost" onClick={() => { setModalAudienciaOpen(false); setEditingAudienciaId(null); setAudienciaError(''); setFormAudienciaGrupoNuevo(false); setFormAudienciaGrupoNuevoValor(''); }}>Cancelar</button>
                <button className="btn btn-primary" onClick={saveAudiencia}>Guardar</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* MODAL CAMBIAR ETAPA */}
      {modalCambiarEtapa && (
        <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setModalCambiarEtapa(false)}>
          <div className="modal" style={{ width: 480 }}>
            <div className="modal-header">
              <div className="modal-title">{etapaActual ? 'Cambiar etapa procesal' : 'Iniciar etapa procesal'}</div>
              <button className="modal-close" onClick={() => setModalCambiarEtapa(false)}>✕</button>
            </div>
            <div className="modal-body">
              {!etapaPersonalizada ? (
                <div>
                  {etapasPlantilla.length > 0 ? (
                    <div>
                      <div style={{ fontSize: 12, color: 'var(--text4)', marginBottom: 10 }}>Seleccioná la etapa según el tipo de juicio:</div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 300, overflowY: 'auto' }}>
                        {etapasPlantilla.map(ep => {
                          const yaTransitada = historialEtapas.some(h => h.nombre === ep.nombre) || etapaActual?.nombre === ep.nombre;
                          const seleccionada = nuevaEtapaNombre === ep.nombre;
                          return (
                            <div
                              key={ep.id}
                              onClick={() => setNuevaEtapaNombre(ep.nombre)}
                              style={{
                                padding: '10px 14px',
                                border: `1.5px solid ${seleccionada ? 'var(--blue)' : 'var(--border)'}`,
                                borderRadius: 8,
                                cursor: 'pointer',
                                background: seleccionada ? 'color-mix(in srgb, var(--blue) 8%, transparent)' : 'var(--surface2)',
                                opacity: yaTransitada ? 0.6 : 1,
                              }}
                            >
                              <div style={{ fontSize: 13, fontWeight: 500, color: yaTransitada ? 'var(--text4)' : 'var(--text)', textDecoration: yaTransitada ? 'line-through' : 'none' }}>
                                {ep.nombre}
                              </div>
                              {ep.requisitos_plantilla?.length > 0 && (
                                <div style={{ fontSize: 11, color: 'var(--text4)', marginTop: 3 }}>
                                  {ep.requisitos_plantilla.length} requisito{ep.requisitos_plantilla.length !== 1 ? 's' : ''}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                      <button className="btn btn-ghost btn-sm" style={{ marginTop: 12, width: '100%' }} onClick={() => { setNuevaEtapaNombre(''); setEtapaPersonalizada(true); }}>
                        Etapa personalizada...
                      </button>
                    </div>
                  ) : (
                    <div>
                      <div style={{ fontSize: 13, color: 'var(--text4)', marginBottom: 12, padding: '10px 14px', background: 'var(--surface2)', borderRadius: 8 }}>
                        {expediente?.tipo_juicio_id
                          ? 'El tipo de juicio no tiene etapas configuradas. Podés ingresar una etapa personalizada.'
                          : 'El expediente no tiene tipo de juicio asignado. Podés ingresar una etapa personalizada.'}
                      </div>
                      <label className="form-label">Nombre de la etapa *</label>
                      <input
                        className="form-input"
                        autoFocus
                        value={nuevaEtapaNombre}
                        onChange={e => setNuevaEtapaNombre(e.target.value)}
                        placeholder="Ej: Etapa de prueba"
                        onKeyDown={e => e.key === 'Enter' && nuevaEtapaNombre.trim() && cambiarEtapa(nuevaEtapaNombre.trim(), null, [])}
                      />
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <button className="btn btn-ghost btn-xs" style={{ marginBottom: 10 }} onClick={() => { setEtapaPersonalizada(false); setNuevaEtapaNombre(''); }}>← Volver a la lista</button>
                  <label className="form-label">Nombre de la etapa *</label>
                  <input
                    className="form-input"
                    autoFocus
                    value={nuevaEtapaNombre}
                    onChange={e => setNuevaEtapaNombre(e.target.value)}
                    placeholder="Ej: Etapa de prueba"
                    onKeyDown={e => e.key === 'Enter' && nuevaEtapaNombre.trim() && cambiarEtapa(nuevaEtapaNombre.trim(), null, [])}
                  />
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={() => setModalCambiarEtapa(false)}>Cancelar</button>
              <button
                className="btn btn-primary"
                disabled={!nuevaEtapaNombre.trim()}
                onClick={() => {
                  if (!nuevaEtapaNombre.trim()) return;
                  const etapaSeleccionada = etapasPlantilla.find(ep => ep.nombre === nuevaEtapaNombre);
                  cambiarEtapa(
                    nuevaEtapaNombre.trim(),
                    etapaSeleccionada?.id || null,
                    etapaSeleccionada?.requisitos_plantilla || []
                  );
                }}
              >
                Confirmar etapa
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL NUEVO REQUISITO */}
      {modalNuevoReq && (
        <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setModalNuevoReq(false)}>
          <div className="modal" style={{ width: 420 }}>
            <div className="modal-header">
              <div className="modal-title">Agregar requisito</div>
              <button className="modal-close" onClick={() => setModalNuevoReq(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-group form-full">
                <label className="form-label">Descripción del requisito *</label>
                <input
                  className="form-input"
                  autoFocus
                  value={nuevoReqTexto}
                  onChange={e => setNuevoReqTexto(e.target.value)}
                  placeholder="Ej: Pericia médica"
                  onKeyDown={e => e.key === 'Enter' && addRequisito()}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={() => setModalNuevoReq(false)}>Cancelar</button>
              <button className="btn btn-primary" disabled={!nuevoReqTexto.trim()} onClick={addRequisito}>Agregar</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL NUEVO INCIDENTE */}
      {modalNuevoIncidente && (
        <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setModalNuevoIncidente(false)}>
          <div className="modal" style={{ width: 500 }}>
            <div className="modal-header">
              <div className="modal-title">Agregar incidente</div>
              <button className="modal-close" onClick={() => setModalNuevoIncidente(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div style={{ background: 'var(--surface2)', border: '0.5px solid var(--border)', borderRadius: 7, padding: '10px 14px', fontSize: 12, color: 'var(--text4)', marginBottom: 16, lineHeight: 1.6 }}>
                El incidente heredará automáticamente el fuero, juzgado, juez, secretaría, actuario, jurisdicción y clientes de <strong style={{ color: 'var(--text)' }}>{expediente?.caratula}</strong>.
              </div>
              <div className="form-grid">
                <div className="form-group form-full">
                  <label className="form-label">Carátula *</label>
                  <input className="form-input" value={formIncidente.caratula} onChange={e => setFormIncidente(f => ({ ...f, caratula: e.target.value }))} placeholder="Carátula del incidente" autoFocus />
                </div>
                <div className="form-group form-full">
                  <label className="form-label">Número de expediente</label>
                  <input className="form-input" value={formIncidente.numero} onChange={e => setFormIncidente(f => ({ ...f, numero: e.target.value }))} placeholder="Opcional" />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={() => setModalNuevoIncidente(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={saveNuevoIncidente} disabled={guardandoIncidente}>
                {guardandoIncidente ? 'Creando...' : 'Crear incidente'}
              </button>
            </div>
          </div>
        </div>
      )}

      {modalEditarExp && (
        <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setModalEditarExp(false)}>
          <div className="modal" style={{ width: 580, maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
            <div className="modal-header">
              <div className="modal-title">Editar expediente</div>
              <button className="modal-close" onClick={() => setModalEditarExp(false)}>✕</button>
            </div>
            <div className="modal-body" style={{ overflowY: 'auto' }}>
              <div className="form-grid">
                <div className="form-group form-full">
                  <label className="form-label">Carátula *</label>
                  <input className="form-input" value={formEditExp.caratula} onChange={e => setFormEditExp(f => ({ ...f, caratula: e.target.value }))} placeholder="Ej: GARCÍA c/ EMPRESA S.A. s/ Despido" autoFocus />
                </div>
                <div className="form-group">
                  <label className="form-label">Número</label>
                  <input className="form-input" value={formEditExp.numero} onChange={e => setFormEditExp(f => ({ ...f, numero: e.target.value }))} placeholder="Ej: 12345/2024" />
                </div>
                <div className="form-group">
                  <label className="form-label">Posición procesal</label>
                  <select className="form-select" value={formEditExp.posicion_procesal} onChange={e => setFormEditExp(f => ({ ...f, posicion_procesal: e.target.value }))}>
                    <option value="actor">Actor</option>
                    <option value="demandado">Demandado</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Jurisdicción</label>
                  <input className="form-input" value={formEditExp.jurisdiccion} onChange={e => setFormEditExp(f => ({ ...f, jurisdiccion: e.target.value }))} placeholder="Ej: Ciudad de Buenos Aires" />
                </div>
                <div className="form-group">
                  <label className="form-label">Fuero</label>
                  <input className="form-input" value={formEditExp.fuero} onChange={e => setFormEditExp(f => ({ ...f, fuero: e.target.value }))} placeholder="Ej: Laboral, Civil..." />
                </div>
                <div className="form-group">
                  <label className="form-label">Juzgado</label>
                  <input className="form-input" value={formEditExp.juzgado} onChange={e => setFormEditExp(f => ({ ...f, juzgado: e.target.value }))} placeholder="Ej: Juzgado N° 3" />
                </div>
                <div className="form-group">
                  <label className="form-label">Juez</label>
                  <input className="form-input" value={formEditExp.juez} onChange={e => setFormEditExp(f => ({ ...f, juez: e.target.value }))} placeholder="Nombre del juez" />
                </div>
                <div className="form-group">
                  <label className="form-label">Secretaría</label>
                  <input className="form-input" value={formEditExp.secretaria} onChange={e => setFormEditExp(f => ({ ...f, secretaria: e.target.value }))} placeholder="Nombre de la secretaría" />
                </div>
                <div className="form-group">
                  <label className="form-label">Tipo de acción</label>
                  <select
                    className="form-select"
                    value={formEditExp.tipo_juicio_id || ''}
                    onChange={e => setFormEditExp(f => ({ ...f, tipo_juicio_id: e.target.value }))}
                  >
                    <option value="">— Sin asignar —</option>
                    {tiposJuicio.map(t => (
                      <option key={t.id} value={t.id}>{t.nombre}</option>
                    ))}
                  </select>
                  {tiposJuicio.length === 0 && (
                    <div style={{ fontSize: 11, color: 'var(--text4)', marginTop: 5 }}>
                      No hay tipos de acción configurados. Podés crearlos desde <strong>Personalización</strong>.
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label className="form-label">Fecha de inicio</label>
                  <input className="form-input" type="date" value={formEditExp.fecha_inicio} onChange={e => setFormEditExp(f => ({ ...f, fecha_inicio: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label className="form-label">Fecha de intervención</label>
                  <input className="form-input" type="date" value={formEditExp.fecha_intervencion} onChange={e => setFormEditExp(f => ({ ...f, fecha_intervencion: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label className="form-label">Parte contraria</label>
                  <input className="form-input" value={formEditExp.parte_contraria} onChange={e => setFormEditExp(f => ({ ...f, parte_contraria: e.target.value }))} placeholder="Nombre de la parte contraria" />
                </div>
                <div className="form-group">
                  <label className="form-label">Letrado contrario</label>
                  <input className="form-input" value={formEditExp.letrado_contrario} onChange={e => setFormEditExp(f => ({ ...f, letrado_contrario: e.target.value }))} placeholder="Nombre del letrado contrario" />
                </div>

                {/* ── SECCIÓN: CLIENTES VINCULADOS ── */}
                <div className="form-group form-full" style={{ borderTop: '1px solid var(--border)', paddingTop: 16, marginTop: 4 }}>
                  <label className="form-label" style={{ color: 'var(--text3)', fontWeight: 700, fontSize: 10, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 8, display: 'block' }}>
                    Clientes vinculados
                  </label>
                  {formEditExp.cliente_ids?.length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 8 }}>
                      {formEditExp.cliente_ids.map(id => {
                        const c = todosClientes.find(x => x.id === id);
                        return c ? (
                          <div key={id} style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '3px 10px', borderRadius: 20, background: 'var(--blue-light)', border: '1px solid var(--blue)', color: 'var(--blue)', fontSize: 12 }}>
                            {[c.apellido, c.nombre].filter(Boolean).join(', ')}
                            <span
                              onClick={() => setFormEditExp(f => ({ ...f, cliente_ids: f.cliente_ids.filter(x => x !== id) }))}
                              style={{ cursor: 'pointer', fontWeight: 700, marginLeft: 2, lineHeight: 1 }}
                            >×</span>
                          </div>
                        ) : null;
                      })}
                    </div>
                  )}
                  <div style={{ position: 'relative' }}>
                    <input
                      className="form-input"
                      placeholder="Buscar y agregar cliente..."
                      value={busquedaClienteEdit}
                      onChange={e => setBusquedaClienteEdit(e.target.value)}
                      onFocus={() => setDropdownClienteEditOpen(true)}
                      onBlur={() => setTimeout(() => setDropdownClienteEditOpen(false), 150)}
                      autoComplete="off" spellCheck={false}
                      style={{ fontSize: 13 }}
                    />
                    {dropdownClienteEditOpen && (
                      <div style={{ position: 'absolute', bottom: '100%', left: 0, right: 0, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8, zIndex: 300, maxHeight: 180, overflowY: 'auto', marginBottom: 4, boxShadow: '0 -4px 16px rgba(0,0,0,0.25)' }}>
                        {todosClientes.filter(c => {
                          const t = busquedaClienteEdit.toLowerCase();
                          return !t || `${c.apellido || ''} ${c.nombre || ''}`.toLowerCase().includes(t);
                        }).map(c => {
                          const ya = formEditExp.cliente_ids?.includes(c.id);
                          return (
                            <div
                              key={c.id}
                              onMouseDown={() => {
                                setFormEditExp(f => ({
                                  ...f,
                                  cliente_ids: ya
                                    ? f.cliente_ids.filter(x => x !== c.id)
                                    : [...(f.cliente_ids || []), c.id],
                                }));
                                setBusquedaClienteEdit('');
                              }}
                              style={{
                                padding: '8px 14px', cursor: 'pointer', fontSize: 13,
                                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                background: ya ? 'var(--blue-light)' : 'transparent',
                                color: ya ? 'var(--blue)' : 'var(--text2)',
                                borderBottom: '1px solid var(--border)',
                              }}
                            >
                              <span>{[c.apellido, c.nombre].filter(Boolean).join(', ')}</span>
                              {ya && <span style={{ fontSize: 12 }}>✓ vinculado</span>}
                            </div>
                          );
                        })}
                        {todosClientes.filter(c => {
                          const t = busquedaClienteEdit.toLowerCase();
                          return !t || `${c.apellido || ''} ${c.nombre || ''}`.toLowerCase().includes(t);
                        }).length === 0 && (
                          <div style={{ padding: '10px 14px', color: 'var(--text4)', fontSize: 13 }}>Sin resultados</div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* ── SECCIÓN: RELACIÓN CON OTROS EXPEDIENTES ── */}
                <div className="form-group form-full" style={{ borderTop: '1px solid var(--border)', paddingTop: 16, marginTop: 4 }}>
                  <label className="form-label" style={{ color: 'var(--text3)', fontWeight: 700, fontSize: 10, letterSpacing: 1, textTransform: 'uppercase' }}>
                    Convertir en incidente — vincular a un expediente principal
                  </label>

                  {/* YA ES INCIDENTE → mostrar principal + opción de desvincular */}
                  {expediente?.expediente_principal_id ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 8, background: '#f3e8ff', border: '1px solid #c4b5fd', marginTop: 6 }}>
                      <span style={{ fontSize: 14 }}>🔗</span>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 11, color: '#7c3aed', fontWeight: 500, marginBottom: 2 }}>Incidente de:</div>
                        <div style={{ fontSize: 13, fontWeight: 600, color: '#5b21b6' }}>{expedientePrincipal?.caratula || '(cargando...)'}</div>
                        {expedientePrincipal?.numero && <div style={{ fontSize: 11, color: '#7c3aed' }}>{expedientePrincipal.numero}</div>}
                      </div>
                      <button
                        type="button"
                        className="btn btn-ghost"
                        style={{ fontSize: 11, color: 'var(--red)', flexShrink: 0 }}
                        onClick={desvinculardePrincipal}
                      >
                        Desvincular
                      </button>
                    </div>
                  ) : (
                    /* ES PRINCIPAL → opción de convertir en incidente */
                    <div style={{ marginTop: 6 }}>
                      {principalConvertir ? (
                        /* Principal elegido: mostrar chip */
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 8, background: '#fef9c3', border: '1px solid #fde68a' }}>
                          <span style={{ fontSize: 14 }}>⚠️</span>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontSize: 11, color: '#92400e', fontWeight: 500, marginBottom: 2 }}>Se convertirá en incidente de:</div>
                            <div style={{ fontSize: 13, fontWeight: 600, color: '#78350f' }}>{principalConvertir.caratula}</div>
                            {principalConvertir.numero && <div style={{ fontSize: 11, color: '#92400e' }}>{principalConvertir.numero}</div>}
                          </div>
                          <span
                            onClick={() => setPrincipalConvertir(null)}
                            style={{ cursor: 'pointer', color: '#92400e', fontWeight: 700, fontSize: 18, lineHeight: 1, flexShrink: 0 }}
                          >×</span>
                        </div>
                      ) : (
                        /* Búsqueda de principal */
                        <div style={{ position: 'relative' }}>
                          <input
                            className="form-input"
                            placeholder="Buscar expediente principal para vincular..."
                            value={busquedaConvertir}
                            onChange={e => { setBusquedaConvertir(e.target.value); buscarExpedientesPrincipales(e.target.value); }}
                            onFocus={() => { setDropdownConvertirOpen(true); buscarExpedientesPrincipales(busquedaConvertir); }}
                            onBlur={() => setTimeout(() => setDropdownConvertirOpen(false), 180)}
                            autoComplete="off" spellCheck={false}
                          />
                          {dropdownConvertirOpen && (resultadosConvertir.length > 0 || busquedaConvertir) && (
                            <div style={{ position: 'absolute', bottom: '100%', left: 0, right: 0, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8, zIndex: 300, maxHeight: 200, overflowY: 'auto', marginBottom: 4, boxShadow: '0 -4px 16px rgba(0,0,0,0.25)' }}>
                              {resultadosConvertir.length === 0 ? (
                                <div style={{ padding: '10px 14px', color: 'var(--text4)', fontSize: 13 }}>Sin resultados</div>
                              ) : resultadosConvertir.map(e => (
                                <div
                                  key={e.id}
                                  onMouseDown={() => { setPrincipalConvertir(e); setBusquedaConvertir(''); setDropdownConvertirOpen(false); }}
                                  style={{ padding: '8px 14px', cursor: 'pointer', fontSize: 13, borderBottom: '1px solid var(--border)' }}
                                >
                                  <div style={{ fontWeight: 500, color: 'var(--text2)' }}>{e.caratula}</div>
                                  {e.numero && <div style={{ fontSize: 11, color: 'var(--text4)' }}>{e.numero}</div>}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                      {!principalConvertir && (
                        <div style={{ fontSize: 11, color: 'var(--text4)', marginTop: 6 }}>
                          Si vinculás un principal, este expediente pasará a ser un incidente de ese expediente al guardar.
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* ── SECCIÓN: ETAPA DE PRUEBA ── */}
                <div className="form-group form-full" style={{ borderTop: '1px solid var(--border)', paddingTop: 16, marginTop: 4 }}>
                  <label className="form-label" style={{ color: 'var(--text3)', fontWeight: 700, fontSize: 10, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 8, display: 'block' }}>
                    Etapa de prueba
                  </label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    {[{ v: true, label: 'Habilitada' }, { v: false, label: 'Deshabilitada' }].map(({ v, label }) => (
                      <button
                        key={String(v)}
                        type="button"
                        className={`btn btn-sm ${(formEditExp.prueba_habilitada ?? true) === v ? 'btn-primary' : 'btn-ghost'}`}
                        onClick={() => setFormEditExp(f => ({ ...f, prueba_habilitada: v }))}
                      >
                        {label}
                      </button>
                    ))}
                  </div>
                  {!(formEditExp.prueba_habilitada ?? true) && (
                    <div style={{ fontSize: 11, color: 'var(--text4)', marginTop: 6 }}>La pestaña Prueba no va a aparecer en este expediente.</div>
                  )}
                </div>
              </div>
            </div>
            <div className="modal-footer" style={{ justifyContent: 'space-between' }}>
              <div>
                {esAdmin && (
                  <button className="btn btn-ghost" onClick={deleteExpediente} style={{ color: '#ef4444' }}>
                    Eliminar expediente
                  </button>
                )}
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn btn-ghost" onClick={() => setModalEditarExp(false)}>Cancelar</button>
                <button className="btn btn-primary" onClick={saveExpediente} disabled={guardandoExp}>
                  {guardandoExp ? 'Guardando...' : principalConvertir ? 'Guardar y convertir en incidente' : 'Guardar cambios'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* MODAL DETALLE ETAPA HISTÓRICA */}
      {etapaHistorialDetalle && (
        <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setEtapaHistorialDetalle(null)} style={{ zIndex: 700 }}>
          <div className="modal" style={{ width: 540, maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
            <div className="modal-header">
              <div>
                <div className="modal-title">{etapaHistorialDetalle.nombre}</div>
                <div style={{ fontSize: 11, color: 'var(--text4)', marginTop: 2 }}>
                  Iniciada el {new Date(etapaHistorialDetalle.fecha_inicio).toLocaleDateString('es-AR')}
                </div>
              </div>
              <button className="modal-close" onClick={() => setEtapaHistorialDetalle(null)}>✕</button>
            </div>
            <div className="modal-body" style={{ overflowY: 'auto' }}>
              {(!etapaHistorialDetalle.expediente_requisitos || etapaHistorialDetalle.expediente_requisitos.length === 0) ? (
                <div style={{ textAlign: 'center', color: 'var(--text4)', fontSize: 13, padding: '20px 0' }}>Sin requisitos registrados en esta etapa</div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {[...etapaHistorialDetalle.expediente_requisitos].sort((a, b) => a.orden - b.orden).map(r => (
                    <div key={r.id} style={{ background: 'var(--surface2)', border: '0.5px solid var(--border)', borderRadius: 8, padding: '12px 14px' }}>
                      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                        <span style={{ fontSize: 16, marginTop: 1 }}>{r.estado === 'completada' ? '✅' : r.estado === 'en curso' ? '🔵' : '⬜'}</span>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 13, fontWeight: 600, color: r.estado === 'completada' ? 'var(--text4)' : 'var(--text)', textDecoration: r.estado === 'completada' ? 'line-through' : 'none', marginBottom: 6 }}>
                            {r.texto}
                          </div>
                          <div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center', gap: 6, overflow: 'hidden' }}>
                            <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 20, fontWeight: 500,
                              background: r.estado === 'completada' ? '#dcfce7' : r.estado === 'en curso' ? '#dbeafe' : 'var(--surface)',
                              color: r.estado === 'completada' ? '#16a34a' : r.estado === 'en curso' ? '#2563eb' : 'var(--text4)',
                              border: '0.5px solid currentColor' }}>
                              {r.estado === 'completada' ? 'Completada' : r.estado === 'en curso' ? 'En curso' : 'Pendiente'}
                            </span>
                            {r.fecha && (
                              <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 20, background: '#eff6ff', color: '#3b82f6', border: '0.5px solid #bfdbfe', fontWeight: 500, whiteSpace: 'nowrap' }}>
                                Agendado para el día {new Date(r.fecha.split('T')[0] + 'T12:00:00').toLocaleDateString('es-AR')}
                              </span>
                            )}
                            {r.fecha_vencimiento && (
                              <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 20, background: '#fefce8', color: '#ca8a04', border: '0.5px solid #fde68a', fontWeight: 500, whiteSpace: 'nowrap' }}>
                                Vence {new Date(r.fecha_vencimiento.split('T')[0] + 'T12:00:00').toLocaleDateString('es-AR')}
                              </span>
                            )}
                            {r.producida_en && (
                              <span style={{ fontSize: 11, color: '#16a34a', fontFamily: 'DM Mono', whiteSpace: 'nowrap' }}>
                                ✓ {new Date(r.producida_en).toLocaleDateString('es-AR')} {new Date(r.producida_en).toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })}
                              </span>
                            )}
                          </div>
                          {r.notas && (
                            <div style={{ marginTop: 8, fontSize: 12, color: 'var(--text3)', background: 'var(--surface)', borderRadius: 6, padding: '6px 10px', borderLeft: '3px solid var(--border)', fontStyle: 'italic' }}>
                              {r.notas}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="modal-footer" style={{ justifyContent: 'space-between' }}>
              <button className="btn btn-danger" onClick={async () => {
                await supabase.from('expediente_etapas').delete().eq('id', etapaHistorialDetalle.id);
                setHistorialEtapas(prev => prev.filter(h => h.id !== etapaHistorialDetalle.id));
                setEtapaHistorialDetalle(null);
              }}>🗑 Eliminar etapa</button>
              <button className="btn btn-ghost" onClick={() => setEtapaHistorialDetalle(null)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL EDITAR ETAPA */}
      {modalEditarEtapa && etapaActual && (
        <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setModalEditarEtapa(false)} style={{ zIndex: 700 }}>
          <div className="modal" style={{ width: 420 }}>
            <div className="modal-header">
              <div className="modal-title">Editar etapa</div>
              <button className="modal-close" onClick={() => setModalEditarEtapa(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label">Nombre de la etapa</label>
                <input
                  className="form-input"
                  autoFocus
                  value={nombreEtapaEdit}
                  onChange={e => setNombreEtapaEdit(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && nombreEtapaEdit.trim() && (async () => {
                    await supabase.from('expediente_etapas').update({ nombre: nombreEtapaEdit.trim() }).eq('id', etapaActual.id);
                    await supabase.from('expedientes').update({ estado_procesal: nombreEtapaEdit.trim() }).eq('id', expedienteId);
                    setModalEditarEtapa(false);
                    fetchEstadoProcesal();
                    onUpdate?.();
                  })()}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={() => setModalEditarEtapa(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={async () => {
                if (!nombreEtapaEdit.trim()) return;
                await supabase.from('expediente_etapas').update({ nombre: nombreEtapaEdit.trim() }).eq('id', etapaActual.id);
                await supabase.from('expedientes').update({ estado_procesal: nombreEtapaEdit.trim() }).eq('id', expedienteId);
                setModalEditarEtapa(false);
                fetchEstadoProcesal();
                onUpdate?.();
              }}>Guardar</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL FICHA REQUISITO */}
      {requisitoDetalleId && (() => {
        const r = requisitosEtapa.find(x => x.id === requisitoDetalleId);
        if (!r) return null;
        return (
          <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setRequisitoDetalleId(null)} style={{ zIndex: 700 }}>
            <div className="modal" style={{ width: 500 }}>
              <div className="modal-header">
                <div className="modal-title" style={{ fontSize: 15 }}>Requisito</div>
                <button className="modal-close" onClick={() => setRequisitoDetalleId(null)}>✕</button>
              </div>
              <div className="modal-body">
                {/* Estado badge */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16, padding: '12px 16px', borderRadius: 10,
                  background: formReqDetalle.estado === 'completada' ? '#dcfce7' : formReqDetalle.estado === 'en curso' ? '#dbeafe' : 'var(--surface2)',
                  border: `1px solid ${formReqDetalle.estado === 'completada' ? '#bbf7d0' : formReqDetalle.estado === 'en curso' ? '#bfdbfe' : 'var(--border)'}`,
                }}>
                  <span style={{
                    width: 9, height: 9, borderRadius: '50%', flexShrink: 0,
                    background: formReqDetalle.estado === 'completada' ? '#16a34a' : formReqDetalle.estado === 'en curso' ? '#2563eb' : '#94a3b8'
                  }} />
                  <span style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.6,
                    color: formReqDetalle.estado === 'completada' ? '#15803d' : formReqDetalle.estado === 'en curso' ? '#1d4ed8' : '#64748b'
                  }}>
                    {formReqDetalle.estado === 'completada' ? '✓ Completada' : formReqDetalle.estado === 'en curso' ? 'En curso' : 'Pendiente'}
                  </span>
                </div>
                <div className="form-grid">
                  <div className="form-group form-full">
                    <label className="form-label">Descripción</label>
                    <input className="form-input" value={formReqDetalle.texto} onChange={e => setFormReqDetalle(f => ({ ...f, texto: e.target.value }))} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Estado</label>
                    <select className="form-select" value={formReqDetalle.estado} onChange={e => setFormReqDetalle(f => ({ ...f, estado: e.target.value }))}>
                      <option value="pendiente">Pendiente</option>
                      <option value="en curso">En curso</option>
                      <option value="completada">Completada</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Fecha de Realización</label>
                    <input className="form-input" type="date" value={formReqDetalle.fecha} onChange={e => setFormReqDetalle(f => ({ ...f, fecha: e.target.value }))} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Fecha de vencimiento</label>
                    <input className="form-input" type="date" value={formReqDetalle.fecha_vencimiento} onChange={e => setFormReqDetalle(f => ({ ...f, fecha_vencimiento: e.target.value }))} />
                  </div>
                  {formReqDetalle.producida_en && (
                    <div className="form-group">
                      <label className="form-label">Producida el</label>
                      <div style={{ fontSize: 13, color: '#16a34a', fontWeight: 500, padding: '8px 12px', background: '#dcfce7', borderRadius: 8, border: '0.5px solid #bbf7d0' }}>
                        ✓ {new Date(formReqDetalle.producida_en).toLocaleDateString('es-AR')} a las {new Date(formReqDetalle.producida_en).toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })}
                      </div>
                    </div>
                  )}
                  <div className="form-group form-full">
                    <label className="form-label">Notas</label>
                    <textarea className="form-textarea" rows={4} placeholder="Agregá observaciones sobre este requisito..." value={formReqDetalle.notas} onChange={e => setFormReqDetalle(f => ({ ...f, notas: e.target.value }))} />
                  </div>
                </div>
              </div>
              <div className="modal-footer" style={{ justifyContent: 'space-between' }}>
                <button className="btn btn-danger" onClick={() => { deleteRequisito(requisitoDetalleId); setRequisitoDetalleId(null); }}>
                  🗑 Eliminar
                </button>
                <div className="flex gap-2">
                  <button className="btn btn-ghost" onClick={() => setRequisitoDetalleId(null)}>Cancelar</button>
                  <button className="btn btn-primary" onClick={saveRequisitoDetalle} disabled={guardandoReq}>
                    {guardandoReq ? 'Guardando...' : 'Guardar'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {toast && <div className="toast">✓ {toast}</div>}

      {/* MODAL NUEVA / EDITAR PRUEBA */}
      {modalPruebaOpen && (
        <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setModalPruebaOpen(false)} style={{ zIndex: 700 }}>
          <div className="modal" style={{ width: 460 }}
            onKeyDown={e => { if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA' && e.target.tagName !== 'SELECT') savePrueba(); }}
          >
            <div className="modal-header">
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1 }}>
                <div style={{ width: 4, height: 28, borderRadius: 2, background: (TIPO_PRUEBA[formPrueba.tipo] || TIPO_PRUEBA.otro).color, flexShrink: 0 }} />
                <div className="modal-title">{editingPruebaId ? 'Editar prueba' : 'Nueva prueba'}</div>
              </div>
              <button className="modal-close" onClick={() => setModalPruebaOpen(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-grid">
                <div className="form-group form-full">
                  <label className="form-label">Tipo</label>
                  <select className="form-select" value={formPrueba.tipo} onChange={e => setFormPrueba(f => ({ ...f, tipo: e.target.value }))}>
                    {Object.entries(TIPO_PRUEBA).map(([k, v]) => (
                      <option key={k} value={k}>{v.label}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group form-full">
                  <label className="form-label">Parte</label>
                  <div style={{ display: 'flex', gap: 8 }}>
                    {[{ value: 'nuestra', label: 'Nuestra' }, { value: 'contraparte', label: 'Contraparte' }].map(opt => (
                      <button
                        key={opt.value}
                        type="button"
                        onClick={() => setFormPrueba(f => ({ ...f, parte: opt.value }))}
                        style={{
                          flex: 1, padding: '7px 0', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer',
                          border: `1.5px solid ${formPrueba.parte === opt.value ? (opt.value === 'nuestra' ? '#3b82f6' : '#ef4444') : 'var(--border)'}`,
                          background: formPrueba.parte === opt.value ? (opt.value === 'nuestra' ? '#eff6ff' : '#fef2f2') : 'var(--surface)',
                          color: formPrueba.parte === opt.value ? (opt.value === 'nuestra' ? '#3b82f6' : '#ef4444') : 'var(--text3)',
                        }}
                      >{opt.label}</button>
                    ))}
                  </div>
                </div>
                {TIPO_PRUEBA[formPrueba.tipo]?.campo_nombre && (
                  <div className="form-group form-full">
                    <label className="form-label">{TIPO_PRUEBA[formPrueba.tipo].campo_nombre}</label>
                    <input className="form-input" autoFocus value={formPrueba.nombre} onChange={e => setFormPrueba(f => ({ ...f, nombre: e.target.value }))} />
                  </div>
                )}
                <div className="form-group form-full">
                  <label className="form-label">Descripción</label>
                  <textarea className="form-textarea" rows={2} value={formPrueba.descripcion} onChange={e => setFormPrueba(f => ({ ...f, descripcion: e.target.value }))} placeholder="Descripción o detalle de la prueba..." />
                </div>
                <div className="form-group form-full">
                  <label className="form-label">Estado</label>
                  <select className="form-select" value={formPrueba.estado} onChange={e => setFormPrueba(f => ({ ...f, estado: e.target.value }))}>
                    {Object.entries(ESTADO_PRUEBA).map(([k, v]) => (
                      <option key={k} value={k}>{v.label}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={() => setModalPruebaOpen(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={savePrueba} disabled={guardandoPrueba}>
                {guardandoPrueba ? 'Guardando...' : 'Guardar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* FICHA PRUEBA — bitácora */}
      {pruebaDetalleId && (() => {
        const p = pruebas.find(x => x.id === pruebaDetalleId);
        if (!p) return null;
        const cfg = TIPO_PRUEBA[p.tipo] || TIPO_PRUEBA.otro;
        const est = ESTADO_PRUEBA[p.estado] || ESTADO_PRUEBA.no_instada;
        const titulo = p.nombre || p.descripcion || cfg.label;
        const EVENTO_ICON = { nota: '📝', tarea: '✅', audiencia: '📅', vencimiento: '⏰' };
        const EVENTO_COLOR = { nota: 'var(--text4)', tarea: '#10b981', audiencia: '#3b82f6', vencimiento: '#ef4444' };
        return (
          <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setPruebaDetalleId(null)} style={{ zIndex: 700 }}>
            <div className="modal" style={{ width: 520, maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
              {/* Header */}
              <div className="modal-header" style={{ flexShrink: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1, minWidth: 0 }}>
                  <div style={{ width: 4, height: 28, borderRadius: 2, background: cfg.color, flexShrink: 0 }} />
                  <div>
                    <div className="modal-title" style={{ fontSize: 14 }}>{titulo}</div>
                    <div style={{ fontSize: 11, color: cfg.color, fontWeight: 600, marginTop: 1 }}>{cfg.label}</div>
                  </div>
                </div>
                <button className="modal-close" onClick={() => setPruebaDetalleId(null)}>✕</button>
              </div>

              {/* Estado + acciones */}
              <div style={{ flexShrink: 0, padding: '10px 20px', borderBottom: '0.5px solid var(--border)', display: 'flex', alignItems: 'center', gap: 10 }}>
                <select
                  className="form-select"
                  style={{ fontSize: 12, padding: '4px 10px', height: 32, width: 'auto', background: est.bg, color: est.color, border: `1px solid ${est.border}`, fontWeight: 600 }}
                  value={p.estado}
                  onChange={async e => {
                    const nuevoEstado = e.target.value;
                    await supabase.from('expediente_pruebas').update({ estado: nuevoEstado }).eq('id', p.id);
                    fetchPruebas();
                  }}
                >
                  {Object.entries(ESTADO_PRUEBA).map(([k, v]) => (
                    <option key={k} value={k}>{v.label}</option>
                  ))}
                </select>
                <div style={{ flex: 1 }} />
                {p.descripcion && <div style={{ fontSize: 12, color: 'var(--text4)', maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.descripcion}</div>}
              </div>

              {/* Bitácora — scrollable */}
              <div className="modal-body" style={{ flex: 1, overflowY: 'auto' }}>
                {/* Botones agregar evento */}
                <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                  {[
                    { tipo: 'nota', label: '+ Nota' },
                    { tipo: 'tarea', label: '+ Tarea' },
                    { tipo: 'audiencia', label: '+ Audiencia' },
                    { tipo: 'vencimiento', label: '+ Vencimiento' },
                  ].map(({ tipo, label }) => (
                    <button
                      key={tipo}
                      className="btn btn-ghost btn-sm"
                      style={{ fontSize: 12, color: EVENTO_COLOR[tipo] }}
                      onClick={() => {
                        setFormEvento({ tipo, descripcion: '', fecha: new Date().toISOString().split('T')[0], hora: '' });
                        setModalEventoOpen(true);
                      }}
                    >
                      {label}
                    </button>
                  ))}
                </div>

                {/* Lista eventos */}
                {pruebaEventos.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '24px 0', color: 'var(--text4)', fontSize: 13 }}>
                    Sin movimientos registrados.<br />
                    <span style={{ fontSize: 12 }}>Usá los botones de arriba para registrar notas, audiencias o vencimientos.</span>
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {pruebaEventos.map(ev => (
                      <div key={ev.id} style={{ display: 'flex', gap: 10, padding: '10px 12px', background: 'var(--surface2)', border: '0.5px solid var(--border)', borderLeft: `3px solid ${EVENTO_COLOR[ev.tipo]}`, borderRadius: 8 }}>
                        <div style={{ fontSize: 15, flexShrink: 0, marginTop: 1 }}>{EVENTO_ICON[ev.tipo]}</div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 }}>
                            <span style={{ fontSize: 10, fontFamily: 'DM Mono', color: 'var(--text4)' }}>
                              {ev.fecha ? new Date(ev.fecha + 'T12:00:00').toLocaleDateString('es-AR') : ''}
                              {ev.hora ? ` ${ev.hora.substring(0, 5)} hs` : ''}
                            </span>
                            <span style={{ fontSize: 10, fontWeight: 700, color: EVENTO_COLOR[ev.tipo], textTransform: 'uppercase', letterSpacing: 0.4 }}>{ev.tipo}</span>
                          </div>
                          <div style={{ fontSize: 13, color: 'var(--text)', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>{ev.descripcion}</div>
                        </div>
                        {esAdmin && (
                          <button
                            className="btn btn-danger btn-xs"
                            style={{ flexShrink: 0, alignSelf: 'flex-start' }}
                            onClick={() => deleteEvento(ev.id)}
                          >🗑</button>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Footer */}
              <div className="modal-footer" style={{ justifyContent: 'space-between', flexShrink: 0 }}>
                {esAdmin ? (
                  <button className="btn btn-danger btn-sm" onClick={() => deletePrueba(p.id)}>Eliminar prueba</button>
                ) : <span />}
                <button className="btn btn-ghost btn-sm" onClick={() => {
                  setEditingPruebaId(p.id);
                  setFormPrueba({ tipo: p.tipo, estado: p.estado, descripcion: p.descripcion || '', nombre: p.nombre || '', parte: p.parte || 'nuestra' });
                  setModalPruebaOpen(true);
                }}>Editar datos</button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* MODAL AGREGAR EVENTO A PRUEBA */}
      {modalEventoOpen && (
        <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setModalEventoOpen(false)} style={{ zIndex: 800 }}>
          <div className="modal" style={{ width: 440 }}
            onKeyDown={e => { if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA' && e.target.tagName !== 'SELECT') saveEvento(); }}
          >
            <div className="modal-header">
              <div className="modal-title">
                {formEvento.tipo === 'nota' ? 'Agregar nota' : formEvento.tipo === 'tarea' ? 'Agregar tarea' : formEvento.tipo === 'audiencia' ? 'Registrar audiencia' : 'Registrar vencimiento'}
              </div>
              <button className="modal-close" onClick={() => setModalEventoOpen(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-grid">
                <div className="form-group form-full">
                  <label className="form-label">{formEvento.tipo === 'audiencia' ? 'Nota (opcional)' : 'Descripción *'}</label>
                  <textarea
                    className="form-textarea"
                    autoFocus
                    rows={3}
                    value={formEvento.descripcion}
                    onChange={e => setFormEvento(f => ({ ...f, descripcion: e.target.value }))}
                    placeholder={
                      formEvento.tipo === 'nota' ? 'Ej: Se diligencia oficio al Registro Civil...' :
                      formEvento.tipo === 'tarea' ? 'Ej: Preparar puntos de pericia' :
                      formEvento.tipo === 'audiencia' ? 'Observaciones sobre la audiencia (opcional)...' :
                      'Ej: Vencimiento para impugnar pericia'
                    }
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">{formEvento.tipo === 'tarea' ? 'Fecha de vencimiento' : 'Fecha'}{formEvento.tipo !== 'tarea' ? ' *' : ''}</label>
                  <input className="form-input" type="date" value={formEvento.fecha} onChange={e => setFormEvento(f => ({ ...f, fecha: e.target.value }))} />
                </div>
                {formEvento.tipo === 'audiencia' && (
                  <div className="form-group">
                    <label className="form-label">Hora</label>
                    <input className="form-input" type="time" value={formEvento.hora} onChange={e => setFormEvento(f => ({ ...f, hora: e.target.value }))} />
                  </div>
                )}
              </div>
              {(formEvento.tipo === 'audiencia' || formEvento.tipo === 'vencimiento' || formEvento.tipo === 'tarea') && (
                <div style={{ fontSize: 12, color: 'var(--text4)', marginTop: 8, padding: '8px 12px', background: 'var(--surface2)', borderRadius: 8, lineHeight: 1.5 }}>
                  {formEvento.tipo === 'audiencia'
                    ? 'Se creará un evento en la pestaña Audiencias de este expediente.'
                    : 'Se creará una tarea en la pestaña Tareas de este expediente.'}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={() => setModalEventoOpen(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={saveEvento} disabled={guardandoEvento}>
                {guardandoEvento ? 'Guardando...' : 'Registrar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* FICHA AUDIENCIA */}
      {audienciaDetalleId && (() => {
        const a = audiencias.find(x => x.id === audienciaDetalleId);
        if (!a) return null;
        const colorTipo = (tipo) => {
          const map = { 'Audiencia': '#ef4444', 'Vencimiento procesal': '#f59e0b', 'Consulta / Turno': '#10b981', 'Reunión': '#3b82f6' };
          return map[tipo] || '#9ca3af';
        };
        const color = colorTipo(a.tipo);
        const estadoBg = a.estado === 'realizado' ? '#dcfce7' : a.estado === 'cancelado' ? '#fee2e2' : 'var(--surface2)';
        const estadoBorder = a.estado === 'realizado' ? '#bbf7d0' : a.estado === 'cancelado' ? '#fecaca' : 'var(--border)';
        const estadoDot = a.estado === 'realizado' ? '#16a34a' : a.estado === 'cancelado' ? '#dc2626' : '#94a3b8';
        const estadoColor = a.estado === 'realizado' ? '#15803d' : a.estado === 'cancelado' ? '#b91c1c' : '#64748b';
        const estadoLabel = a.estado === 'realizado' ? 'Realizado' : a.estado === 'cancelado' ? 'Cancelado' : 'Pendiente';
        return (
          <>
          <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setAudienciaDetalleId(null)} style={{ zIndex: 700 }}>
            <div className="modal" style={{ width: 480 }}>
              <div className="modal-header">
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1, minWidth: 0 }}>
                  <div style={{ width: 4, height: 28, borderRadius: 2, background: color, flexShrink: 0 }} />
                  <div className="modal-title" style={{ fontSize: 15 }}>{a.titulo}</div>
                </div>
                <button className="modal-close" onClick={() => setAudienciaDetalleId(null)}>✕</button>
              </div>
              <div className="modal-body">
                {/* Estado badge */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16, padding: '12px 16px', borderRadius: 10, background: estadoBg, border: `1px solid ${estadoBorder}` }}>
                  <span style={{ width: 9, height: 9, borderRadius: '50%', flexShrink: 0, background: estadoDot }} />
                  <span style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.6, color: estadoColor }}>{estadoLabel}</span>
                  <span style={{ marginLeft: 'auto', background: color + '18', color, padding: '2px 10px', borderRadius: 10, fontSize: 11, fontWeight: 600 }}>{a.tipo}</span>
                </div>
                {/* Fecha y hora */}
                <div style={{ display: 'flex', gap: 10, marginBottom: 14, flexWrap: 'wrap' }}>
                  {a.fecha && (
                    <span style={{ fontSize: 12, padding: '3px 10px', borderRadius: 20, background: '#eff6ff', color: '#3b82f6', border: '0.5px solid #bfdbfe', fontWeight: 500 }}>
                      {new Date(a.fecha + 'T12:00:00').toLocaleDateString('es-AR', { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' })}
                    </span>
                  )}
                  {a.hora && (
                    <span style={{ fontSize: 12, padding: '3px 10px', borderRadius: 20, background: 'var(--surface2)', color: 'var(--text)', border: '0.5px solid var(--border)', fontWeight: 500, fontFamily: 'DM Mono' }}>
                      {a.hora.substring(0, 5)} hs
                    </span>
                  )}
                </div>
                {/* Notas */}
                {a.notas && (
                  <div style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.7, padding: '10px 14px', background: 'var(--surface2)', borderRadius: 8, whiteSpace: 'pre-wrap' }}>
                    {a.notas}
                  </div>
                )}
              </div>
              <div className="modal-footer" style={{ justifyContent: 'space-between' }}>
                {esAdmin ? (
                  <button className="btn btn-danger btn-sm" onClick={() => {
                    setConfirm({
                      titulo: 'Eliminar evento',
                      mensaje: '¿Eliminar este evento?',
                      onConfirmar: async () => {
                        setConfirm(null);
                        await softDelete('agenda', a.id);
                        setAudienciaDetalleId(null);
                        fetchAudiencias();
                        showToast('Evento eliminado');
                      }
                    });
                  }}>Eliminar</button>
                ) : <span />}
                <div style={{ display: 'flex', gap: 8 }}>
                  <button
                    className="btn btn-ghost"
                    onClick={() => { setNuevoGrupoAudInput(''); setModalGrupoAudOpen(true); }}
                  >
                    📁 {a.grupo ? 'Cambiar grupo' : 'Agregar a grupo'}
                  </button>
                  <button className="btn btn-primary" onClick={() => {
                    setAudienciaDetalleId(null);
                    setEditingAudienciaId(a.id);
                    setFormAudiencia({ titulo: a.titulo || '', tipo: a.tipo || 'Audiencia', fecha: a.fecha || '', hora: a.hora?.substring(0,5) || '', notas: a.notas || '', estado: a.estado || 'pendiente' });
                    setModalAudienciaOpen(true);
                  }}>Editar</button>
                </div>
              </div>
            </div>
          </div>

          {/* Sub-modal: selección de grupo para audiencia */}
          {modalGrupoAudOpen && (
            <div className="modal-overlay" style={{ zIndex: 900 }} onMouseDown={e => e.target === e.currentTarget && setModalGrupoAudOpen(false)}>
              <div className="modal" style={{ width: 400 }}>
                <div className="modal-header">
                  <div className="modal-title" style={{ fontSize: 15 }}>
                    {a.grupo ? 'Cambiar grupo' : 'Agregar a grupo'}
                  </div>
                  <button className="modal-close" onClick={() => setModalGrupoAudOpen(false)}>✕</button>
                </div>
                <div className="modal-body">
                  {gruposAudienciasOrden.length > 0 && (
                    <>
                      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text4)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 }}>
                        Grupos existentes
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 18 }}>
                        {gruposAudienciasOrden.map(g => (
                          <button
                            key={g}
                            onClick={() => {
                              const grupoOriginal = a.grupo ?? null;
                              const id = a.id;
                              setAudiencias(prev => prev.map(x => x.id === id ? { ...x, grupo: g } : x));
                              supabase.from('agenda').update({ grupo: g }).eq('id', id)
                                .then(({ error }) => { if (error) setAudiencias(prev => prev.map(x => x.id === id ? { ...x, grupo: grupoOriginal } : x)); });
                              setModalGrupoAudOpen(false);
                              setAudienciaDetalleId(null);
                            }}
                            style={{
                              display: 'flex', alignItems: 'center', gap: 8,
                              padding: '9px 14px', borderRadius: 8, cursor: 'pointer', border: 'none',
                              background: a.grupo === g ? 'var(--blue-light)' : 'var(--surface2)',
                              color: a.grupo === g ? 'var(--blue)' : 'var(--text)',
                              fontWeight: a.grupo === g ? 600 : 400,
                              fontSize: 14, textAlign: 'left',
                              outline: a.grupo === g ? '1.5px solid var(--blue)' : '1px solid var(--border)',
                            }}
                          >
                            <span>📁</span>
                            <span style={{ flex: 1 }}>{g}</span>
                            {a.grupo === g && <span style={{ fontSize: 12 }}>✓ actual</span>}
                          </button>
                        ))}
                      </div>
                      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text4)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 }}>
                        O crear nuevo grupo
                      </div>
                    </>
                  )}
                  {gruposAudienciasOrden.length === 0 && (
                    <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text4)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 }}>
                      Crear nuevo grupo
                    </div>
                  )}
                  <div style={{ display: 'flex', gap: 8 }}>
                    <input
                      className="form-input"
                      value={nuevoGrupoAudInput}
                      onChange={e => setNuevoGrupoAudInput(e.target.value)}
                      placeholder="Nombre del grupo..."
                      onKeyDown={e => {
                        if (e.key === 'Enter' && nuevoGrupoAudInput.trim()) {
                          const g = nuevoGrupoAudInput.trim();
                          const grupoOriginal = a.grupo ?? null;
                          const id = a.id;
                          setAudiencias(prev => prev.map(x => x.id === id ? { ...x, grupo: g } : x));
                          supabase.from('agenda').update({ grupo: g }).eq('id', id)
                            .then(({ error }) => { if (error) setAudiencias(prev => prev.map(x => x.id === id ? { ...x, grupo: grupoOriginal } : x)); });
                          setModalGrupoAudOpen(false);
                          setAudienciaDetalleId(null);
                        }
                      }}
                      style={{ flex: 1 }}
                      autoFocus={gruposAudienciasOrden.length === 0}
                    />
                    <button
                      className="btn btn-primary"
                      disabled={!nuevoGrupoAudInput.trim()}
                      onClick={() => {
                        const g = nuevoGrupoAudInput.trim();
                        const grupoOriginal = a.grupo ?? null;
                        const id = a.id;
                        setAudiencias(prev => prev.map(x => x.id === id ? { ...x, grupo: g } : x));
                        supabase.from('agenda').update({ grupo: g }).eq('id', id)
                          .then(({ error }) => { if (error) setAudiencias(prev => prev.map(x => x.id === id ? { ...x, grupo: grupoOriginal } : x)); });
                        setModalGrupoAudOpen(false);
                        setAudienciaDetalleId(null);
                      }}
                    >
                      Crear
                    </button>
                  </div>
                </div>
                {a.grupo && (
                  <div className="modal-footer" style={{ justifyContent: 'flex-start', paddingTop: 8 }}>
                    <button
                      className="btn btn-danger"
                      onClick={() => {
                        const grupoOriginal = a.grupo ?? null;
                        const id = a.id;
                        setAudiencias(prev => prev.map(x => x.id === id ? { ...x, grupo: null } : x));
                        supabase.from('agenda').update({ grupo: null }).eq('id', id)
                          .then(({ error }) => { if (error) setAudiencias(prev => prev.map(x => x.id === id ? { ...x, grupo: grupoOriginal } : x)); });
                        setModalGrupoAudOpen(false);
                        setAudienciaDetalleId(null);
                      }}
                    >
                      ✕ Quitar del grupo actual
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
          </>
        );
      })()}

      {tareaDetalleId && (
        <TareaDetalle
          tareaId={tareaDetalleId}
          onClose={() => setTareaDetalleId(null)}
          onCompletar={() => { fetchTareas(); setTareaDetalleId(null); }}
          onEdit={(tarea) => { setTareaDetalleId(null); openEditTarea(tarea); }}
          grupos={gruposOrden}
          onCambiarGrupo={grupo => {
            const id = tareaDetalleId;
            const grupoNuevo = grupo || null;
            const grupoOriginal = tareas.find(t => t.id === id)?.grupo ?? null;
            setTareas(prev => prev.map(t => t.id === id ? { ...t, grupo: grupoNuevo } : t));
            supabase.from('tareas').update({ grupo: grupoNuevo }).eq('id', id)
              .then(({ error }) => { if (error) setTareas(prev => prev.map(t => t.id === id ? { ...t, grupo: grupoOriginal } : t)); });
          }}
        />
      )}

      {verCliente && (
        <>
          <div className="drawer-overlay" style={{ zIndex: 600 }} onMouseDown={() => setVerCliente(null)} />
          <div className="drawer" style={{ zIndex: 601 }}>
            <ClienteDetalle
              clienteId={verCliente}
              onClose={() => setVerCliente(null)}
              onEdit={(cliente) => { setClienteEdit(cliente); setVerCliente(null); }}
              backLabel="← Volver al expediente"
            />
          </div>
        </>
      )}

      <ClienteModal
        open={!!clienteEdit}
        editing={clienteEdit}
        onClose={() => setClienteEdit(null)}
        onSaved={() => { setClienteEdit(null); fetchExpediente(); }}
      />

      <ConfirmModal
        open={!!confirm}
        titulo={confirm?.titulo}
        mensaje={confirm?.mensaje}
        onConfirmar={confirm?.onConfirmar}
        onCancelar={() => setConfirm(null)}
      />

      {/* Modal asignar tarea / grupo */}
      {modalAsignarOpen && (
        <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setModalAsignarOpen(false)} style={{ zIndex: 1600 }}>
          <div className="modal" style={{ width: 460 }}>
            <div className="modal-header">
              <div className="modal-title">
                {asignarItems.length > 1
                  ? `Asignar grupo — ${asignarTitulo} (${asignarItems.length} ${asignarTipo === 'audiencia' ? 'audiencias' : 'tareas'})`
                  : asignarTipo === 'audiencia' ? 'Asignar audiencia' : 'Asignar tarea'}
              </div>
              <button className="modal-close" onClick={() => setModalAsignarOpen(false)}>✕</button>
            </div>
            <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', padding: '0 20px' }}>
              {[['nueva', 'Nueva asignación de tarea'], ['existente', 'Agregar a asignación ya creada']].map(([key, label]) => (
                <button key={key} onClick={() => setAsignarTab(key)} style={{
                  padding: '10px 16px', fontWeight: asignarTab === key ? 600 : 400,
                  borderBottom: asignarTab === key ? '2px solid var(--blue)' : '2px solid transparent',
                  background: 'none', border: 'none', cursor: 'pointer',
                  color: asignarTab === key ? 'var(--blue)' : 'var(--text4)', fontSize: 13
                }}>{label}</button>
              ))}
            </div>
            <div className="modal-body">
              <div style={{ marginBottom: 14, padding: '8px 12px', background: 'var(--surface2)', borderRadius: 8, maxHeight: 100, overflowY: 'auto' }}>
                {asignarItems.map(t => (
                  <div key={t.id} style={{ fontSize: 12, color: 'var(--text2)', padding: '1px 0' }}>• {t.titulo}</div>
                ))}
              </div>
              {asignarTab === 'nueva' ? (
                <>
                  <div className="form-group">
                    <label className="form-label">Título de la asignación de tarea</label>
                    <input className="form-input" value={asignarForm.titulo} onChange={e => setAsignarForm(f => ({ ...f, titulo: e.target.value }))} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Fecha de Realización</label>
                    <input type="date" className="form-input" value={asignarForm.fecha} onChange={e => setAsignarForm(f => ({ ...f, fecha: e.target.value }))} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Asignar a</label>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                      {asignarUsuarios.map(u => (
                        <label key={u.id} style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13 }}>
                          <input type="checkbox" checked={asignarForm.asignados_a.includes(u.id)}
                            onChange={e => setAsignarForm(f => ({
                              ...f, asignados_a: e.target.checked ? [...f.asignados_a, u.id] : f.asignados_a.filter(id => id !== u.id)
                            }))} />
                          {u.nombre}
                        </label>
                      ))}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="search-box" style={{ marginBottom: 10 }}>
                    <span style={{ color: 'var(--text4)' }}>⌕</span>
                    <input placeholder="Buscar asignación..." value={asignarBusqueda} onChange={e => setAsignarBusqueda(e.target.value)} autoComplete="off" />
                  </div>
                  <div style={{ maxHeight: 260, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 4 }}>
                    {asignarAsignaciones
                      .filter(a => !asignarBusqueda || a.titulo.toLowerCase().includes(asignarBusqueda.toLowerCase()))
                      .map(a => (
                        <div key={a.id} onClick={() => setAsignarExistenteId(a.id)} style={{
                          padding: '8px 12px', borderRadius: 8, cursor: 'pointer',
                          background: asignarExistenteId === a.id ? '#eff6ff' : 'var(--surface2)',
                          border: `1px solid ${asignarExistenteId === a.id ? 'var(--blue)' : 'transparent'}`
                        }}>
                          <div style={{ fontSize: 13, fontWeight: 500 }}>{a.titulo}</div>
                          <div style={{ fontSize: 11, color: 'var(--text4)' }}>{a.fecha}</div>
                        </div>
                      ))}
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={() => setModalAsignarOpen(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={guardarAsignar} disabled={asignarGuardando}>
                {asignarGuardando ? 'Guardando...' : asignarTab === 'nueva' ? 'Crear asignación de tarea' : 'Agregar a asignación'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

// Wrapper sortable (@dnd-kit) para una tarea. El handle ⠿ recibe los listeners.
function SortableTarea({ id, cardProps }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  const style = { transform: CSS.Translate.toString(transform), transition };
  return (
    <TareaCard
      {...cardProps}
      setNodeRef={setNodeRef}
      sortableStyle={style}
      dragHandleProps={{ ...attributes, ...listeners }}
      sortableDragging={isDragging}
    />
  );
}

// Wrapper sortable (@dnd-kit) para un grupo de tareas. Contiene su propia lista sortable.
function SortableGrupo({
  id, nombre, memberTokens, tareasGrupo, colapsado, onToggleColapso,
  renombrando, renombreValor, setRenombreValor, onRenombrarStart, onRenombrarConfirm, onRenombrarCancel,
  onAsignarGrupo, onNuevaTarea, onEliminar, esAdmin, cardPropsFor,
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  const style = {
    transform: CSS.Translate.toString(transform), transition,
    opacity: isDragging ? 0.5 : 1,
    marginBottom: 12, background: '#e2e6ea', border: '1px solid #c8cdd4', borderRadius: 10, overflow: 'hidden',
  };
  return (
    <div ref={setNodeRef} style={style}>
      <div
        style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', cursor: 'pointer' }}
        onClick={onToggleColapso}
      >
        <span
          className="drag-handle"
          style={{ cursor: 'grab', fontSize: 14, color: 'var(--text4)', flexShrink: 0, lineHeight: 1, userSelect: 'none', touchAction: 'none', opacity: 1, padding: '2px 4px' }}
          {...attributes} {...listeners}
          onClick={e => e.stopPropagation()}
          title="Arrastrar grupo"
        >⠿</span>
        <span style={{ fontSize: 13 }}>📁</span>
        {renombrando ? (
          <input
            className="form-input"
            style={{ height: 24, padding: '0 6px', fontSize: 12, flex: 1 }}
            autoFocus
            value={renombreValor}
            onChange={e => setRenombreValor(e.target.value)}
            onClick={e => e.stopPropagation()}
            onKeyDown={e => {
              e.stopPropagation();
              if (e.key === 'Enter') onRenombrarConfirm();
              if (e.key === 'Escape') onRenombrarCancel();
            }}
          />
        ) : (
          <span style={{ flex: 1, fontSize: 12, fontWeight: 600, color: 'var(--text2)', textTransform: 'uppercase', letterSpacing: 0.5 }}>
            {nombre} ({tareasGrupo.length})
          </span>
        )}
        <span style={{ fontSize: 11, color: 'var(--text4)', marginLeft: 'auto' }}>{colapsado ? '▸' : '▾'}</span>
        <button className="btn btn-primary btn-xs" onClick={e => { e.stopPropagation(); onAsignarGrupo(); }} style={{ fontSize: 10, padding: '2px 8px' }}>Asignar</button>
        <button className="btn btn-ghost btn-xs" title="Nueva tarea en este grupo" onClick={e => { e.stopPropagation(); onNuevaTarea(); }}>+ tarea</button>
        <button className="btn btn-ghost btn-xs" title="Editar grupo" onClick={e => { e.stopPropagation(); onRenombrarStart(); }}>✎ Editar grupo</button>
        {esAdmin && <button className="btn btn-danger btn-xs" title="Eliminar grupo" onClick={e => { e.stopPropagation(); onEliminar(); }}>🗑</button>}
      </div>
      {!colapsado && (
        <>
          <div style={{ height: '0.5px', background: 'var(--border)', margin: '0 8px' }} />
          <div style={{ padding: '6px 8px 8px' }}>
            <SortableContext items={memberTokens} strategy={verticalListSortingStrategy}>
              {tareasGrupo.map(t => (
                <SortableTarea key={'t:' + t.id} id={'t:' + t.id} cardProps={cardPropsFor(t)} />
              ))}
              {tareasGrupo.length === 0 && (
                <div style={{ fontSize: 12, color: 'var(--text4)', textAlign: 'center', padding: '12px 0' }}>Arrastrá tareas acá</div>
              )}
            </SortableContext>
          </div>
        </>
      )}
    </div>
  );
}

function TareaCard({ tarea, onToggle, onFijar, onEdit, onDelete, onDescartar, onReactivar, onVerDetalle, onAsignar, prioridadColor, formatDate, today, completada, descartada, prueba, setNodeRef, sortableStyle, dragHandleProps, sortableDragging, overlay }) {
  const esAdmin = useEsAdmin();
  const vencida = tarea.fecha_vencimiento && tarea.fecha_vencimiento < today && !completada && !descartada;
  const opacidad = completada || descartada ? 0.55 : 1;
  return (
    <div
      ref={setNodeRef}
      className="tarea-card"
      style={{
        ...(sortableStyle || {}),
        opacity: sortableDragging ? 0.4 : opacidad,
        boxShadow: overlay ? '0 8px 24px rgba(0,0,0,0.18)' : undefined,
        border: overlay ? '1px solid var(--blue)' : undefined,
        background: overlay ? 'var(--surface)' : undefined,
      }}
    >
      {dragHandleProps && (
        <div className="drag-handle" style={{ touchAction: 'none' }} {...dragHandleProps}>⠿</div>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, flexShrink: 0 }}>
        {!descartada && !completada && (
          <button
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, fontSize: 11, opacity: tarea.fijada ? 1 : 0.3, color: tarea.fijada ? 'var(--blue)' : 'var(--text4)', lineHeight: 1 }}
            onClick={() => onFijar(tarea)}
            title={tarea.fijada ? 'Desfijar' : 'Fijar'}
          >📌</button>
        )}
        {!descartada && (
          <input type="checkbox" className="tarea-check" checked={!!completada} onChange={() => onToggle(tarea)} onClick={e => e.stopPropagation()} style={{ marginTop: 0 }} />
        )}
        {descartada && (
          <div style={{ width: 16, height: 16, borderRadius: 3, border: '1.5px solid var(--text4)', flexShrink: 0 }} />
        )}
      </div>
      <div
        style={{ flex: 1, cursor: onVerDetalle ? 'pointer' : undefined }}
        onMouseDown={e => { e.currentTarget._mdx = e.clientX; e.currentTarget._mdy = e.clientY; }}
        onClick={e => {
          if (Math.abs(e.clientX - (e.currentTarget._mdx ?? e.clientX)) > 5 || Math.abs(e.clientY - (e.currentTarget._mdy ?? e.clientY)) > 5) return;
          onVerDetalle?.(tarea.id);
        }}
      >
        <div className="tarea-titulo" style={{ textDecoration: completada || descartada ? 'line-through' : 'none', color: descartada ? 'var(--text4)' : undefined }}>{tarea.titulo}</div>
        {tarea.descripcion && <div className="tarea-sub">{tarea.descripcion}</div>}
        <div style={{ display: 'flex', gap: 8, marginTop: 5, flexWrap: 'wrap', alignItems: 'center' }}>
          {descartada && <span className="badge badge-gray" style={{ fontSize: 10 }}>Descartada</span>}
          {tarea.fijada && !descartada && <span className="badge badge-blue" style={{ fontSize: 10 }}>📌 Fijada</span>}
          {tarea.prioridad === 'urgente' && !descartada && <span className="badge badge-red" style={{ fontSize: 10 }}>Urgente</span>}
          {tarea.prioridad === 'muy importante' && !descartada && <span className="badge" style={{ fontSize: 10, background: '#fef3c7', color: '#b45309', border: '1px solid #fcd34d' }}>Muy importante</span>}
          {tarea.fecha && (
            <span style={{ fontSize: 11, padding: '1px 7px', borderRadius: 20, background: '#eff6ff', color: '#3b82f6', border: '0.5px solid #bfdbfe', fontWeight: 500 }}>
              Agendado para el día {formatDate(tarea.fecha)}
            </span>
          )}
          {tarea.fecha_vencimiento && (
            <span style={{ fontSize: 11, padding: '1px 7px', borderRadius: 20, background: vencida ? '#fee2e2' : '#fefce8', color: vencida ? '#dc2626' : '#ca8a04', border: `0.5px solid ${vencida ? '#fecaca' : '#fde68a'}`, fontWeight: 500 }}>
              Vencimiento {formatDate(tarea.fecha_vencimiento)}{vencida ? ' — VENCIDA' : ''}
            </span>
          )}
          {completada && tarea.completada_en && (
            <span style={{ fontSize: 10, color: 'var(--text4)' }}>
              ✓ {new Date(tarea.completada_en).toLocaleString('es-AR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' })}
            </span>
          )}
          {prueba && (
            <span style={{ fontSize: 10, padding: '1px 7px', borderRadius: 20, background: (TIPO_PRUEBA[prueba.tipo] || TIPO_PRUEBA.otro).color + '18', color: (TIPO_PRUEBA[prueba.tipo] || TIPO_PRUEBA.otro).color, border: `0.5px solid ${(TIPO_PRUEBA[prueba.tipo] || TIPO_PRUEBA.otro).color}40`, fontWeight: 600, whiteSpace: 'nowrap' }}>
              📋 {(TIPO_PRUEBA[prueba.tipo] || TIPO_PRUEBA.otro).label}{prueba.label ? ` · ${prueba.label}` : ''}
            </span>
          )}
        </div>
      </div>
      <div className="flex gap-1">
        {descartada ? (
          <button className="btn btn-ghost btn-xs" style={{ fontSize: 10, padding: '2px 8px' }} onClick={() => onReactivar(tarea.id)}>Reactivar</button>
        ) : (
          <>
            {onAsignar && (
              <button className="btn btn-primary btn-xs" style={{ fontSize: 10, padding: '2px 8px' }} onClick={onAsignar}>Asignar</button>
            )}
            <button className="btn btn-ghost btn-xs" style={{ color: 'var(--text4)', fontSize: 10, padding: '2px 7px' }} onClick={() => onDescartar(tarea.id)}>Descartar</button>
          </>
        )}
        {esAdmin && <button className="btn btn-danger btn-xs" onClick={() => onDelete(tarea.id)}>🗑</button>}
      </div>
    </div>
  );
}

// Wrapper sortable (@dnd-kit) para una audiencia.
function SortableAudiencia({ id, cardProps }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  const style = { transform: CSS.Translate.toString(transform), transition };
  return (
    <AudienciaCard
      {...cardProps}
      setNodeRef={setNodeRef}
      sortableStyle={style}
      dragHandleProps={{ ...attributes, ...listeners }}
      sortableDragging={isDragging}
    />
  );
}

// Wrapper sortable (@dnd-kit) para un grupo de audiencias.
function SortableGrupoAudiencia({
  id, nombre, memberTokens, audsGrupo, colapsado, onToggleColapso,
  renombrando, renombreValor, setRenombreValor, onRenombrarStart, onRenombrarConfirm, onRenombrarCancel,
  onAsignarGrupo, onNuevaAudiencia, onEliminar, esAdmin, cardPropsFor,
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  const style = {
    transform: CSS.Translate.toString(transform), transition,
    opacity: isDragging ? 0.5 : 1,
    marginBottom: 12, background: '#e2e6ea', border: '1px solid #c8cdd4', borderRadius: 10, overflow: 'hidden',
  };
  return (
    <div ref={setNodeRef} style={style}>
      <div
        style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', cursor: 'pointer' }}
        onClick={onToggleColapso}
      >
        <span
          className="drag-handle"
          style={{ cursor: 'grab', fontSize: 14, color: 'var(--text4)', flexShrink: 0, lineHeight: 1, userSelect: 'none', touchAction: 'none', opacity: 1, padding: '2px 4px' }}
          {...attributes} {...listeners}
          onClick={e => e.stopPropagation()}
          title="Arrastrar grupo"
        >⠿</span>
        <span style={{ fontSize: 13 }}>📁</span>
        {renombrando ? (
          <input
            className="form-input"
            style={{ height: 24, padding: '0 6px', fontSize: 12, flex: 1 }}
            autoFocus
            value={renombreValor}
            onChange={e => setRenombreValor(e.target.value)}
            onClick={e => e.stopPropagation()}
            onKeyDown={e => {
              e.stopPropagation();
              if (e.key === 'Enter') onRenombrarConfirm();
              if (e.key === 'Escape') onRenombrarCancel();
            }}
          />
        ) : (
          <span style={{ flex: 1, fontSize: 12, fontWeight: 600, color: 'var(--text2)', textTransform: 'uppercase', letterSpacing: 0.5 }}>
            {nombre} ({audsGrupo.length})
          </span>
        )}
        <span style={{ fontSize: 11, color: 'var(--text4)', marginLeft: 'auto' }}>{colapsado ? '▸' : '▾'}</span>
        <button className="btn btn-primary btn-xs" style={{ fontSize: 10, padding: '2px 8px' }} onClick={e => { e.stopPropagation(); onAsignarGrupo(); }}>Asignar</button>
        <button className="btn btn-ghost btn-xs" onClick={e => { e.stopPropagation(); onNuevaAudiencia(); }}>+ audiencia</button>
        <button className="btn btn-ghost btn-xs" onClick={e => { e.stopPropagation(); onRenombrarStart(); }}>✎ Editar grupo</button>
        {esAdmin && <button className="btn btn-danger btn-xs" onClick={e => { e.stopPropagation(); onEliminar(); }}>🗑</button>}
      </div>
      {!colapsado && (
        <>
          <div style={{ height: '0.5px', background: 'var(--border)', margin: '0 8px' }} />
          <div style={{ padding: '6px 8px 8px' }}>
            <SortableContext items={memberTokens} strategy={verticalListSortingStrategy}>
              {audsGrupo.map(a => (
                <SortableAudiencia key={'a:' + a.id} id={'a:' + a.id} cardProps={{ ...cardPropsFor(a), inGroup: true }} />
              ))}
              {audsGrupo.length === 0 && (
                <div style={{ fontSize: 12, color: 'var(--text4)', textAlign: 'center', padding: '12px 0' }}>Arrastrá audiencias acá</div>
              )}
            </SortableContext>
          </div>
        </>
      )}
    </div>
  );
}

// Definida a nivel de módulo para que React nunca la remonte (referencia estable).
function AudienciaCard({ a, inGroup, onClickCard, onClickAsignar, onCambiarEstado, onDelete, esAdmin, prueba, setNodeRef, sortableStyle, dragHandleProps, sortableDragging, overlay }) {
  const colorTipo = (tipo) => {
    const map = { 'Audiencia': '#ef4444', 'Vencimiento procesal': '#f59e0b', 'Consulta / Turno': '#10b981', 'Reunión': '#3b82f6' };
    return map[tipo] || '#9ca3af';
  };
  const todayStr = new Date().toISOString().split('T')[0];
  const esPasadaPendiente = a.fecha && a.fecha < todayStr && a.estado === 'pendiente';
  const realizada = a.estado === 'realizado';
  const cancelada = a.estado === 'cancelado';
  return (
    <div
      ref={setNodeRef}
      className="audiencia-drag-card"
      style={{
        ...(sortableStyle || {}),
        display: 'flex', gap: 12, padding: '10px 12px',
        background: overlay ? 'var(--surface)' : inGroup ? 'var(--surface, #fff)' : 'var(--surface2)',
        border: overlay ? '1px solid var(--blue)' : inGroup ? 'none' : '0.5px solid var(--border)',
        opacity: sortableDragging ? 0.4 : (realizada || cancelada) ? 0.65 : 1,
        borderLeft: `3px solid ${colorTipo(a.tipo)}`,
        borderRadius: 8, marginBottom: 4, alignItems: 'flex-start',
        cursor: 'pointer',
        boxShadow: overlay ? '0 8px 24px rgba(0,0,0,0.18)' : undefined
      }}
      onMouseDown={e => { e.currentTarget._mdx = e.clientX; e.currentTarget._mdy = e.clientY; }}
      onClick={e => {
        if (Math.abs(e.clientX - (e.currentTarget._mdx ?? e.clientX)) > 5 || Math.abs(e.clientY - (e.currentTarget._mdy ?? e.clientY)) > 5) return;
        onClickCard?.();
      }}
    >
      {dragHandleProps && (
        <div
          className="drag-handle"
          style={{ touchAction: 'none', alignSelf: 'center' }}
          {...dragHandleProps}
          onClick={e => e.stopPropagation()}
        >⠿</div>
      )}
      {/* Fecha */}
      <div style={{ minWidth: 72, paddingTop: 1 }}>
        <div style={{ fontFamily: 'DM Mono', fontSize: 11, color: colorTipo(a.tipo), fontWeight: 600 }}>
          {a.fecha ? new Date(a.fecha + 'T12:00:00').toLocaleDateString('es-AR') : '—'}
        </div>
        {a.hora && <div style={{ fontSize: 11, color: 'var(--text4)' }}>{a.hora.substring(0, 5)}</div>}
        {esPasadaPendiente && <div style={{ fontSize: 10, color: '#dc2626', fontWeight: 700, marginTop: 2 }}>Ya pasó</div>}
      </div>
      {/* Contenido */}
      <div style={{ flex: 1, cursor: 'pointer', minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--text)' }}>{a.titulo}</div>
        <div style={{ marginTop: 3, display: 'flex', gap: 5, flexWrap: 'wrap' }}>
          <span style={{ background: colorTipo(a.tipo) + '18', color: colorTipo(a.tipo), padding: '1px 7px', borderRadius: 10, fontSize: 10, fontWeight: 600 }}>{prueba ? 'Prueba' : a.tipo}</span>
          {prueba && (
            <span style={{ fontSize: 10, padding: '1px 7px', borderRadius: 10, background: (TIPO_PRUEBA[prueba.tipo] || TIPO_PRUEBA.otro).color + '18', color: (TIPO_PRUEBA[prueba.tipo] || TIPO_PRUEBA.otro).color, border: `0.5px solid ${(TIPO_PRUEBA[prueba.tipo] || TIPO_PRUEBA.otro).color}40`, fontWeight: 600, whiteSpace: 'nowrap' }}>
              📋 {(TIPO_PRUEBA[prueba.tipo] || TIPO_PRUEBA.otro).label}{prueba.label ? ` · ${prueba.label}` : ''}
            </span>
          )}
        </div>
      </div>
      {/* Acciones derecha */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 5, flexShrink: 0 }} onClick={e => e.stopPropagation()}>
        {/* Fila 1: estado / acciones rápidas */}
        <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
          {realizada ? (
            <>
              <span className="badge badge-green" style={{ fontSize: 10 }}>Realizado</span>
              {onCambiarEstado && (
                <button onClick={() => onCambiarEstado('pendiente')} title="Volver a pendiente"
                  style={{ background: 'none', border: 'none', color: 'var(--text4)', fontSize: 11, cursor: 'pointer', padding: '0 2px', lineHeight: 1 }}>↩</button>
              )}
            </>
          ) : cancelada ? (
            <>
              <span className="badge badge-red" style={{ fontSize: 10 }}>Cancelado</span>
              {onCambiarEstado && (
                <button onClick={() => onCambiarEstado('pendiente')} title="Volver a pendiente"
                  style={{ background: 'none', border: 'none', color: 'var(--text4)', fontSize: 11, cursor: 'pointer', padding: '0 2px', lineHeight: 1 }}>↩</button>
              )}
            </>
          ) : esPasadaPendiente ? (
            <>
              <button onClick={() => onCambiarEstado?.('realizado')}
                style={{ background: '#dcfce7', color: '#15803d', border: '1px solid #bbf7d0', borderRadius: 6, padding: '2px 7px', fontSize: 10, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                ✓ Realizada
              </button>
              <button onClick={() => onCambiarEstado?.('cancelado')}
                style={{ background: '#fee2e2', color: '#b91c1c', border: '1px solid #fecaca', borderRadius: 6, padding: '2px 7px', fontSize: 10, fontWeight: 600, cursor: 'pointer' }}>
                ✕ Cancelar
              </button>
            </>
          ) : (
            <>
              <span className="badge badge-gray" style={{ fontSize: 10 }}>Pendiente</span>
              <button onClick={() => onCambiarEstado?.('cancelado')} title="Marcar como cancelada"
                style={{ background: '#fee2e2', color: '#b91c1c', border: '1px solid #fecaca', borderRadius: 6, padding: '2px 7px', fontSize: 10, fontWeight: 600, cursor: 'pointer' }}>
                ✕ Cancelar
              </button>
            </>
          )}
        </div>
        {/* Fila 2: Asignar + borrar */}
        <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
          <button className="btn btn-primary btn-xs" style={{ fontSize: 10, padding: '2px 8px' }} onClick={() => onClickAsignar?.()}>Asignar</button>
          {esAdmin && onDelete && (
            <button className="btn btn-danger btn-xs" onClick={onDelete} title="Eliminar">🗑</button>
          )}
        </div>
      </div>
    </div>
  );
}